/* ============================================================
   HERZ DER KARTEN – cart-drawer.js
   Cart Sections API: Drawer-Inhalt wird serverseitig gerendert
   (sections/cart-drawer.liquid). Mutationen liefern frisches HTML
   + Inventar in EINER Antwort -> 1 Roundtrip statt /cart.js + eval.
   Laedt auf jeder Seite VOR cart-page.js, product-page.js und gradedguard.js und traegt
   darum ausser dem Drawer die geteilten Cart-Module (Reihenfolge in der Datei):
     window.cartSwapA11y        Fokus-Rueckgabe + Ansage nach einem Section-Swap (Drawer, /cart, Dialog)
     window.cartRabattKurzform  Kurzform «Sale» der Rabatt-Pille per Messung (Drawer, /cart)
     window.hdkCart             der eine Weg fuer Cart-Mutationen (alle Add- und Update-Wege)
     window.cartMengenwahl      Mengenwahl 1–5 / «6+» + Feld der Zeile (Drawer, /cart)
     window.cartMehr            Mehr-Dialog #cart-mehr (Drawer, /cart)
     CartDrawer                 der Drawer selbst (auch window.CartDrawer)
     window.onCartAdd           Erfolgspfad von hdkCart.add ausserhalb von stattDrawer
   ============================================================ */

// i18n-Bruecke: aus layout/theme.liquid injiziert (window.themeStrings / window.routes).
// Bewusst ZUWEISUNG statt const-Deklaration: alle Theme-Skripte teilen sich den globalen
// Scope, eine zweite `const T` wuerde einen SyntaxError werfen und die Datei stilllegen.
// Die Fallbacks halten die Datei lauffaehig, falls das Layout die Injection nicht liefert.
window.themeStrings = window.themeStrings || {};
window.routes = window.routes || {};


// ============================================================
// Fokus-Rueckgabe + Ansage nach einem Section-Swap (Audit 2026-10-02, A11Y-4)
// Geteilt von Drawer (CartDrawer unten) und /cart (assets/cart-page.js, laedt
// nach dieser Datei). Problem: jede Mengenaenderung ersetzt den Zeilen-Bereich
// per innerHTML — das fokussierte Control (Mengenwahl, Entfernen) verschwindet, der Fokus
// faellt auf <body>, und Screenreader hoeren nichts von der neuen Menge.
// Loesung (patterns.md «Fokus-Rueckgabe nach einem Section-Swap»):
//  - VOR dem Request merken, welches Element der Zeile den Fokus hatte
//    (data-key der Zeile + «feld»/«auswahl»/«entfernen»/«zeile»); NACH dem
//    Swap das Gegenstueck in der neuen Zeile fokussieren. Faellt es weg (Select bzw.
//    Feld der Mengenwahl ausgeblendet), das sichtbare Control der Mengenwahl;
//    ist die Zeile weg, der Titel der Nachbarzeile;
//    sonst der Fallback des Aufrufers (Drawer: Schliessen-Knopf).
//    Nur wenn der Fokus vorher IN der Zeile lag — ein Blur-Commit (Fokus ist
//    schon woanders) oder ein Maus-Klick ohne Fokus bleibt unberuehrt;
//    preventScroll, kein Fokus aufs Mengenfeld als Ersatz (Handy-Tastatur).
//  - Polite Live-Region AUSSERHALB des getauschten Bereichs sagt Menge und
//    Total an (Texte als data-Attribute aus den Locales, DE+EN).
// Zuweisung an window statt const: alle Theme-Skripte teilen den globalen Scope.
// ============================================================
window.cartSwapA11y = {
  esc(key) { return (window.CSS && CSS.escape) ? CSS.escape(key) : key; },

  // Der Line-Key ist «<variant>:<hash>», und der Hash wechselt, sobald sich die
  // Rabatt-Zuordnung der Zeile aendert (Dealeasy-Staffel: 2 -> 3 Stueck = neuer
  // Key). Darum erst exakt, dann ueber die Varianten-ID.
  zeile(container, key) {
    if (!key) return null;
    const exakt = container.querySelector('.cart-item[data-key="' + this.esc(key) + '"]');
    if (exakt) return exakt;
    const variante = String(key).split(':')[0];
    return container.querySelector('.cart-item[data-key^="' + this.esc(variante + ':') + '"]');
  },

  // Vor dem Request: Titel der geaenderten Zeile (Ansage) und — falls der Fokus
  // in IRGENDEINER Zeile des Bereichs liegt (bei einem Blur-Commit kann das die
  // Nachbarzeile sein) — deren Key, Position und die Art des Elements.
  vorher(container, key) {
    const zeile = this.zeile(container, key);
    const zeilen = Array.from(container.querySelectorAll('.cart-item'));
    const a = document.activeElement;
    const fokusZeile = a && container.contains(a) ? a.closest('.cart-item') : null;
    let fokus = null;
    if (fokusZeile) {
      fokus = a.matches('input.cart-item__qty-num') ? 'feld'
        : a.matches('select.cart-item__qty-select') ? 'auswahl'
        : a.classList.contains('cart-item__remove') ? 'entfernen' : 'zeile';
    }
    return {
      key,
      titel: zeile ? ((zeile.querySelector('.cart-item__title') || {}).textContent || '').trim() : '',
      fokus,
      fokusKey: fokusZeile ? fokusZeile.dataset.key : null,
      index: fokusZeile ? zeilen.indexOf(fokusZeile) : -1,
    };
  },

  fokusZurueck(container, info, notfall) {
    if (!info || !info.fokus) return;
    const zeile = this.zeile(container, info.fokusKey);
    let ziel = null;
    if (zeile) {
      // Mengenwahl (Drawer und /cart): Select (Menge 1–5) und
      // Feld (ab 6) liegen in derselben Box, sichtbar ist genau eines. Fehlt das gemerkte,
      // ist das sichtbare der Mengenwahl der Ersatz; 'entfernen' steht nach einem
      // Blur-Commit noch in der Zeile.
      if (info.fokus === 'feld') ziel = zeile.querySelector('input.cart-item__qty-num:not([hidden])');
      else if (info.fokus === 'auswahl') ziel = zeile.querySelector('select.cart-item__qty-select:not([hidden])');
      else if (info.fokus === 'entfernen') ziel = zeile.querySelector('.cart-item__remove');
      else if (info.fokus === 'zeile') ziel = zeile.querySelector('.cart-item__title');
      if (!ziel) ziel = zeile.querySelector('.cart-item__menge select:not([hidden]), .cart-item__menge input:not([hidden])');
      if (!ziel) ziel = zeile.querySelector('.cart-item__title');
    } else {
      const zeilen = container.querySelectorAll('.cart-item');
      const nachbar = zeilen[Math.min(info.index, zeilen.length - 1)];
      ziel = nachbar ? nachbar.querySelector('.cart-item__title') : null;
    }
    if (!ziel) ziel = notfall;
    if (ziel) ziel.focus({ preventScroll: true });
  },

  // Ansage: «Titel: Menge N, Total CHF x» bzw. «Titel entfernt, Total CHF x».
  // totalEl ist das Total-Element NACH dem Swap; der Strichpreis darin zaehlt nicht.
  ansagen(region, container, info, totalEl) {
    if (!region || !info || !info.titel) return;
    let total = '';
    if (totalEl) {
      const kopie = totalEl.cloneNode(true);
      kopie.querySelectorAll('.cart-total-was').forEach((s) => s.remove());
      total = kopie.textContent.replace(/\s+/g, ' ').trim();
    }
    const zeile = this.zeile(container, info.key);
    const feld = zeile && zeile.querySelector('input.cart-item__qty-num');
    let text;
    if (feld) {
      text = (region.dataset.tplMenge || '').replace('__QTY__', feld.value);
    } else {
      text = total ? (region.dataset.tplEntfernt || '') : (region.dataset.tplLeer || '');
    }
    text = text.replace('__TITLE__', info.titel).replace('__TOTAL__', total);
    // Wurde die Eingabe vor dem Senden auf den Deckel geklemmt (cartMengenwahl, Audit A-10), steht
    // der Grund vorne — sonst hoerte der Screenreader nur die neue Menge.
    if (info.klemmung) text = info.klemmung + '. ' + text;
    this.melden(region, text);
  },

  // Text in eine Live-Region. Gleicher Text zweimal (z.B. zweimal dieselbe Menge) wuerde nicht
  // erneut angesagt — erst leeren, dann im naechsten Frame schreiben.
  melden(region, text) {
    if (!region || !text) return;
    region.textContent = '';
    requestAnimationFrame(() => { region.textContent = text; });
  },
};

// ============================================================
// Kurzform «Sale» der Rabattzeile — geteilt von Drawer (CartDrawer.rabattBinden unten) und
// /cart (rabattBinden in assets/cart-page.js, laedt nach dieser Datei). Beide Flaechen
// tragen dieselbe Rabattzeile (snippets/cart-line-item.liquid):
// Rabatttitel als Pille, Betrag daneben, bei Titeln mit dem Wort «Sale» dazu die Kurzform
// «Sale» (.cart-item__discount-kurz, standardmaessig aus; cart-drawer.css).
// Ob Pille und Betrag auf EINE Zeile passen, haengt an Titel, Betrag, Sprache und Schrift —
// das kann CSS nicht pruefen (es gibt keine Query auf «Text passt»), darum misst JS:
// Kurzform aus, dann pro Rabattzeile pruefen, ob der Betrag in der Flex-Zeile der Pille
// steht; wenn nicht, is-kurz setzen (die Pille zeigt dann «Sale»). Kriterium: Oberkante des
// Betrags ueber der Unterkante der Pille. Nicht «gleiche Oberkante»: die Rabattzeile richtet
// an der Grundlinie aus, auf einer Zeile liegt die Oberkante des Betrags 1.5 px unter der der
// Pille; in der zweiten Flex-Zeile beginnt er erst unter der Pille
// (+ 2 px Zeilenabstand). Nur Rabattzeilen mit Kurzform; andere Titel brechen um.
// Ohne Layout-Thrashing: erst alle Klassen weg, dann alle messen, dann alle setzen — eine
// erzwungene Layout-Runde pro Durchlauf.
// Wann gemessen wird, entscheidet jede Flaeche selbst: ihre Knoten leben verschieden lang
// (der Drawer-Body ueberlebt jeden Swap, die Liste auf /cart nicht). Der Drawer misst nur
// offen (CartDrawer.rabattMessen, Audit Warenkorb P-6): geschlossen kostet die Messung
// zwei erzwungene Layouts der ganzen Seite im Ladefenster, obwohl
// sie dort niemand sieht; showPanel misst beim Oeffnen synchron nach.
// Zuweisung an window statt const: alle Theme-Skripte teilen den globalen Scope.
// VENDOR:lb-sale-kurzform — ob eine Kurzform im Markup steht, haengt am Wort «Sale» im
// Dealeasy-Rabatttitel (Admin-Namensgebung, docs/vendor-kopplungen.md «Warenkorb»).
// ============================================================
window.cartRabattKurzform = (wurzel) => {
  if (!wurzel) return;
  const zeilen = Array.from(wurzel.querySelectorAll('.cart-item__discount'))
    .filter((z) => z.querySelector('.cart-item__discount-kurz'));
  zeilen.forEach((z) => z.classList.remove('is-kurz'));
  const zuLang = zeilen.map((z) => {
    const pille = z.querySelector('.cart-item__discount-label');
    const betrag = z.querySelector('.cart-item__discount-amount');
    if (!pille || !betrag) return false;
    return betrag.getBoundingClientRect().top >= pille.getBoundingClientRect().bottom - 1;
  });
  zeilen.forEach((z, i) => { if (zuLang[i]) z.classList.add('is-kurz'); });
};

// Neu messen bei Breitenaenderung von wurzel — EIN Beobachter fuer Drawer-Body und /cart-Liste
// (Block 4 des Warenkorb-Audits, F-8). Nur Breite und im
// naechsten Frame: das Umschalten aendert die Hoehe der wurzel,
// und eine Groessenaenderung des beobachteten Knotens im eigenen Callback meldet die
// Spezifikation als Fehlerereignis «ResizeObserver loop completed with undelivered
// notifications» (Chrome meldet es nicht, andere Browser koennen). Kosten: ein Frame
// Verzug, nur beim Ziehen ueber eine Schwelle; beim Start und nach einem Swap misst der
// Aufrufer sofort. Rueckgabe: der Observer (der Aufrufer meldet ihn ab, wenn wurzel ersetzt
// wird) oder null ohne ResizeObserver. messen (optional): eigene Messfunktion statt
// window.cartRabattKurzform(wurzel) — der Drawer reicht seine Weiche «nur offen» herein.
window.cartRabattKurzform.beobachten = (wurzel, messen) => {
  if (!wurzel || !('ResizeObserver' in window)) return null;
  const lauf = messen || (() => window.cartRabattKurzform(wurzel));
  let breite = null;
  let raf = null;
  const ro = new ResizeObserver((eintraege) => {
    const neu = eintraege[0].contentRect.width;
    if (neu === breite) return;
    breite = neu;
    if (!raf) raf = requestAnimationFrame(() => { raf = null; lauf(); });
  });
  ro.observe(wurzel);
  return ro;
};

// ============================================================
// Tastaturfokus in Kartenstreifen — geteilt von Drawer (Fueller-Streifen, Seitenpanel ab 900) und
// /cart (Fueller- und Cross-Selling-Streifen unter 900). Block 1.6 des Warenkorb-Audits (D-2;
// fokussierte Karte ins Bild, Snapping unveraendert):
// der Browser scrollt eine per Tab fokussierte Karte «nearest» halb ins Bild, der Pflicht-Snap
// (scroll-snap-type: x mandatory) rastet danach auf die vorige Karte zurueck — die fokussierte
// Karte laege ausserhalb. Darum bei focusin: liegt die Karte (samt ihrem scroll-margin, im Seitenpanel der Abstand zum
// Kanten-Fade) nicht ganz im Streifen, holt scrollIntoView sie herein — eine Karte ist selbst
// Snap-Ziel (scroll-snap-align: start), der Snap haelt sie dann im Bild. Delegiert an einer Wurzel,
// die jeden Swap ueberlebt (Drawer-Root, .cart-page). Zuweisung an window statt const: alle
// Theme-Skripte teilen den globalen Scope.
// ============================================================
window.cartStreifenFokus = (wurzel) => {
  if (!wurzel) return;
  wurzel.addEventListener('focusin', (e) => {
    const karte = e.target.closest('.cart-filler__card');
    const streifen = karte && karte.closest('.cart-filler__strip');
    if (!streifen) return;
    const k = karte.getBoundingClientRect();
    const s = streifen.getBoundingClientRect();
    const st = getComputedStyle(karte);
    const rand = (seite) => parseFloat(st['scrollMargin' + seite]) || 0;
    const ganz = k.left - rand('Left') >= s.left - 0.5 && k.right + rand('Right') <= s.right + 0.5
      && k.top - rand('Top') >= s.top - 0.5 && k.bottom + rand('Bottom') <= s.bottom + 0.5;
    if (!ganz) karte.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
};

// ============================================================
// hdkCart — EIN Weg fuer Cart-Mutationen (Audit 2026-10-02 CQ-2, M2 Block A)
// Ein Modul statt eigener Kopien je Aufrufer (Zeilen-Meldung in Drawer UND /cart, Add mit
// Sections-Vertrag in Produktseite, GradedGuard und Warenkorbfueller) — sonst hat jeder
// Add-Weg sein eigenes Fehlerbild nach einem abgelehnten Add.
// Hier global (cart-drawer.js laedt auf jeder Seite, vor allen Aufrufern):
//  - Fehlerklassen (Block 0.5 des Warenkorb-Audits, R-2/R-5/R-8/C-4: zuruecksetzen plus
//    Meldung, beide Flaechen gleich). Jede Antwort von update und add
//    traegt bei Misserfolg `art`:
//      'abgelehnt' — 4xx ausser 429, praktisch immer 422: die Anzeige ist veraltet bzw.
//                    der Artikel nicht (mehr) kaufbar (Kommentar in update);
//      'server'    — 429 oder 5xx, oder eine 2xx-Antwort ohne lesbares JSON: der Shop ist
//                    gestoert, am Warenkorb hat sich nichts geaendert;
//      'netz'      — fetch wirft (offline, Funkloch) oder die Zeitgrenze ZEITGRENZE_MS
//                    (AbortController) ist abgelaufen — ohne sie bliebe die Flaeche bei
//                    haengenden Requests ohne Meldung gesperrt.
//    'netz' und 'server' laden nichts neu: die Mengenwahl stellt den Server-Wert wieder her
//    und die Zeile zeigt eine eigene Meldung (stoerungsText, zeilenStoerung) — ein Neuladen
//    landet offline in der Browser-Fehlerseite, ohne Zuruecksetzen zeigte der Drawer eine
//    nie gespeicherte Menge.
//  - update(updates, sections)   /cart/update.js; { ok, cart } bzw. { ok:false,
//    status, art, meldung }. Abgelehnt heisst: die Anzeige ist veraltet (422-Kommentar
//    in update) — der Drawer laedt den Server-Stand und zeigt einen eigenen
//    Hinweis, /cart laedt die Seite neu. `meldung` ist Shopifys Rohtext und nur
//    fuers Log, NIE Kundentext. Wirft nicht.
//  - add(eintraege, haken)        /cart/add.js mit dem Sections-Vertrag des
//    Drawers ('cart-drawer,cart-inventory'). Array -> {items:[…]} — alle Aufrufer
//    senden ein Array (Audit Warenkorb R-10): nur das items-Format klemmt Shopify auf
//    den Bestand (422 mit Teilmenge), das Einzelformat {id, quantity} nimmt jede Menge
//    an (HTTP 200). Ein Objekt ginge weiter im Einzelformat hinaus; kein Aufrufer nutzt
//    das, der Unit-Test hdk-cart.test.js wacht darueber. Danach EIN Fehlerbild fuer
//    alle: Erfolg -> window.onCartAdd(antwort);
//    abgelehnt (422), Server- oder Netzfehler -> CartDrawer.addFehlgeschlagen(meldung):
//    Drawer offen, Server-Stand (Shopify bucht bei 422 ein, was verfuegbar ist), in der
//    Hinweiszeile ein Kundentext (addMeldung: Shopifys Mengenmeldung, sonst
//    eigene Texte je Fehlerklasse) bzw. haken.fallback.
//    haken.vorDrawer(ergebnis) laeuft davor — dort setzt der Aufrufer seine
//    eigene Oberflaeche zurueck (Knopf, Mengen, cartQty).
//    haken.stattDrawer(ergebnis) uebernimmt das Ende — Erfolg wie Fehler —, wo der Drawer
//    nicht aufgehen soll oder schon offen ist: auf /cart Fueller-Plus und Dialogkauf
//    (cart-page.js; dazu haken.sections = SECTIONS_SEITE, 'main-cart' plus der
//    Drawer-Vertrag — die Seite rendert sich selbst neu und meldet einen Fehler an der
//    Karte) und der Dialogkauf im Drawer (CartDrawer.mehrKaufen: der
//    Drawer steht hinter dem Dialog, die Meldung gehoert an die Karte im Dialog).
//  - zeilenFehler(root, key, msg) eigene, lokalisierte Meldung im Warnslot einer
//    Cart-Zeile (Klemmung auf data-max) — nie Shopifys Rohtext aus update.
//  - zeilenStoerung(root, key, msg) die Netz-/Server-Meldung einer Zeile in eigenem Element
//    (role="alert", auf allen Breiten sichtbar — der Warnslot ist auf /cart unter 1150 px
//    aus und steht darueber in der schmalen Hinweis-Spalte); der naechste Swap nimmt sie weg.
// Sprache der mitbestellten Sections: Shopify rendert die Sections einer Cart-Mutation im
// Kontext von sections_url, ohne das Feld im Kontext des HTTP-Referers (Cart-API-Doku
// «Bundled section rendering»). Echte Browser senden auf /en einen /en-Referer (Live ohne
// Referrer-Policy) und bekommen englische Sections; deutsch kommen sie ohne Referer
// (unterdrueckter Referer) und am lokalen Dev-Server (Referer 127.0.0.1)
// (docs/decisions.md 2026-10-26 (1), Korrektur). Darum geben update und
// add sections_url = window.routes.root mit (root_slash aus layout/theme.liquid: DE «/»,
// EN «/en/»), sobald sie Sections bestellen: der Kontext haengt dann nicht am Referer
// und ist derselbe wie bei den GET-Abrufen (holeSections, rerenderFromServer), die ihn ueber
// den Pfad mitbringen.
// Zuweisung an window statt const: alle Theme-Skripte teilen den globalen Scope.
// ============================================================
window.hdkCart = {
  SECTIONS_DRAWER: 'cart-drawer,cart-inventory',

  // sections_url zur Nutzlast, wenn sie Sections bestellt (Befund im Kopf des Blocks).
  mitSectionsUrl(nutzlast) {
    if (nutzlast.sections) nutzlast.sections_url = window.routes.root || '/';
    return nutzlast;
  },

  // Zeitgrenze fuer update und add: 15 s (Block 0.5). update.js mit 60 Positionen und
  // main-cart braucht 1.9 s, add.js mit 60 Positionen 1.7 s — 15 s trennt einen
  // langsamen von einem haengenden Request mit Abstand.
  ZEITGRENZE_MS: 15000,

  // POST mit Zeitgrenze; liest die Antwort als JSON. -> { res, daten } (daten null, wenn die
  // Antwort kein JSON ist) oder { fehler } (Netzfehler, Zeitgrenze). Wirft nicht.
  async senden(url, nutzlast) {
    const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    const uhr = ctrl ? setTimeout(() => ctrl.abort(), this.ZEITGRENZE_MS) : null;
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(nutzlast),
        signal: ctrl ? ctrl.signal : undefined
      });
      let daten = null;
      try { daten = await res.json(); } catch (e) { if (e && e.name === 'AbortError') throw e; }
      return { res, daten };
    } catch (fehler) {
      return { fehler };
    } finally {
      if (uhr) clearTimeout(uhr);
    }
  },

  // Fehlerklasse einer Antwort von senden (Lesart im Kopf des Blocks); null = Erfolg.
  art(antwort) {
    if (antwort.fehler) return 'netz';
    const s = antwort.res.status;
    if (s === 429 || s >= 500) return 'server';
    if (!antwort.res.ok) return 'abgelehnt';
    return antwort.daten ? null : 'server';
  },

  // Kundentext einer Netz-/Server-Stoerung (Locales cart.network_error / cart.server_error).
  stoerungsText(art) {
    const t = window.themeStrings || {};
    return (art === 'server' ? t.cartServerError : t.cartNetworkError) || '';
  },

  async update(updates, sections) {
    const antwort = await this.senden(window.routes.cartUpdate, this.mitSectionsUrl({ updates, sections }));
    const art = this.art(antwort);
    if (art === 'netz' || art === 'server') {
      return { ok: false, status: antwort.res ? antwort.res.status : 0, art, meldung: antwort.fehler ? String(antwort.fehler.name || antwort.fehler) : '' };
    }
    const res = antwort.res;
    if (art === 'abgelehnt') {
      // Shopify liefert bei Fehlern HTTP 422 mit gueltigem JSON, aber OHNE
      // .sections/.item_count. Zwei belegte Ursachen, beide heissen «die Anzeige
      // zeigt einen Warenkorb, den der Server so nicht hat»:
      //  (a) Request ohne gueltigen cart-Cookie -> «Parameter updates ist
      //      ungültig.» (der haeufige Fall im
      //      Feld: Tab lange offen oder aus dem Verlauf/bfcache restauriert,
      //      Bestellung in einem anderen Tab oder per Shop-App-Cart-Sync
      //      abgeschlossen, Cookie geloescht). Andere Payload-Fehler (null, NaN,
      //      Strings, falsche Hashes) liefern 200 oder (b).
      //  (b) unbekannter Line-Key -> «Cannot find variant».
      // Darum laden die Aufrufer den Server-Stand bzw. die Seite; der Text in
      // `meldung` geht nur ins Log (docs/decisions.md 2026-10-09).
      // Eine zu hohe MENGE lehnt update.js NICHT ab (350 bei Bestand 14 -> HTTP 200);
      // Bestands-422 gibt es nur bei add.js, und dort nur im items-Format, das alle Add-Wege
      // senden (das Einzelformat {id, quantity} nimmt ebenfalls jede Menge an,
      // Audit Warenkorb R-10). Deshalb klemmen beide Flaechen getippte Mengen selbst
      // (hdk.normalizeQty) und sperren die Optionen ueber dem Deckel (data-max). Ohne diesen Zweig liefe der Erfolgspfad und
      // updateCounter(undefined) loeschte den Zaehler.
      const err = antwort.daten || {};
      return { ok: false, status: res.status, art, meldung: err.description || err.message || '' };
    }
    return { ok: true, cart: antwort.daten };
  },

  // Kundentext eines fehlgeschlagenen Adds. Shopifys `description` nur, wenn sie eine Menge
  // nennt (Teilmengen-422 im items-Format: «Aufgrund der Verfügbarkeit wurden nur 2 Artikel
  // …», «Du kannst nur 4 … hinzufügen» — storefront-lokalisiert und fuer die Kundschaft
  // hilfreich). Alles andere ist ein Rohtext (z. B. ausverkaufte Variante «Kann Variante
  // nicht finden», geloeschte «Cannot find variant» englisch auf DE, Audit R-8) und wird durch
  // cart.add_unavailable ersetzt; Netz und Server haben eigene Texte. '' = Fallback des
  // Aufrufers. `message` («Cart Error») ist nie Kundentext.
  addMeldung(art, daten) {
    const t = window.themeStrings || {};
    if (art === 'netz' || art === 'server') return this.stoerungsText(art);
    const d = (daten && daten.description) || '';
    if (!d) return '';
    return /\d/.test(d) ? d : (t.cartAddUnavailable || '');
  },

  async add(eintraege, haken) {
    const h = haken || {};
    const nutzlast = Array.isArray(eintraege) ? { items: eintraege } : Object.assign({}, eintraege);
    nutzlast.sections = h.sections || this.SECTIONS_DRAWER;
    this.mitSectionsUrl(nutzlast);
    const antwort = await this.senden(window.routes.cartAdd, nutzlast);
    const art = this.art(antwort);
    // 422 (items-Format, alle Aufrufer): Shopify bucht trotzdem ein, was verfuegbar ist
    // (Server-Stand laden die Aufrufer). Ein Objekt im Einzelformat klemmt nicht und kaeme
    // ohne 422 durch (Kommentar in update, Audit R-10).
    const ergebnis = art
      ? { ok: false, status: antwort.res ? antwort.res.status : 0, art, meldung: this.addMeldung(art, antwort.daten), fehler: antwort.fehler }
      : { ok: true, daten: antwort.daten };
    if (!ergebnis.ok) console.error('Add to cart failed:', ergebnis.fehler || ('cart/add.js HTTP ' + ergebnis.status + ' ' + ((antwort.daten && antwort.daten.description) || '')));
    if (h.vorDrawer) h.vorDrawer(ergebnis);
    if (h.stattDrawer) {
      await h.stattDrawer(ergebnis);
      return ergebnis;
    }
    if (ergebnis.ok) {
      if (typeof window.onCartAdd === 'function') await window.onCartAdd(ergebnis.daten);
    } else {
      await CartDrawer.addFehlgeschlagen(ergebnis.meldung || h.fallback || '');
    }
    return ergebnis;
  },

  zeilenFehler(root, key, msg) {
    if (!root || !msg || !key) return;
    const sel = (window.CSS && CSS.escape) ? CSS.escape(key) : key;
    const line = root.querySelector('.cart-item[data-key="' + sel + '"]');
    if (!line) return;
    let el = line.querySelector('.cart-item__stock-warning');
    if (!el) {
      el = document.createElement('p');
      el.className = 'cart-item__stock-warning';
      (line.querySelector('.cart-item__info') || line).appendChild(el);
    }
    el.textContent = msg;
  },

  // Netz-/Server-Meldung an einer Zeile (Lesart im Kopf des Blocks). role="alert": Screenreader
  // hoeren sie, ohne dass der Fokus das Control der Zeile verlaesst.
  zeilenStoerung(root, key, msg) {
    if (!root || !msg || !key) return;
    const line = window.cartSwapA11y ? window.cartSwapA11y.zeile(root, key) : null;
    if (!line) return;
    let el = line.querySelector('.cart-item__stoerung');
    if (!el) {
      el = document.createElement('p');
      el.className = 'cart-item__stoerung';
      el.setAttribute('role', 'alert');
      (line.querySelector('.cart-item__info') || line).appendChild(el);
    }
    el.textContent = msg;
  },
};

// ============================================================
// Mengenwahl der Warenkorbzeile — EINE Implementierung fuer Drawer (CartDrawer.init unten) und
// /cart (cart-page.js, laedt nach dieser Datei). Markup: snippets/cart-line-item.liquid,
// .cart-item__menge — Auswahl 1–5 und «6+» (Wert 6), ab 6 an DERSELBEN Stelle das tippbare
// Feld; Select und Feld liegen in derselben Box, genau eines ist sichtbar (Liquid entscheidet
// nach item.quantity).
// Zustaende und Uebergaenge:
//  - Select (Menge 1–5): eine Zahl waehlen sendet sofort (change) — durch dieselbe Regel
//    wie das Feld (hdk.normalizeQty, Klemmung an data-max), Mutation ueber die Flaeche
//    (flaeche.senden -> hdkCart.update).
//  - «6+» waehlen: Select aus, Feld ein (vorbelegt 6 = data-liste + 1, bzw. der Deckel,
//    falls kleiner), fokussiert, Wert markiert — noch kein Request (zeigeFeld).
//  - Feld: Enter oder Verlassen der Mengengruppe sendet (onInput). Eine gueltige Menge unter 6
//    schaltet vorher zurueck aufs Select mit dieser Zahl; leer/ungueltig sendet nichts und
//    zeigt den Server-Stand (unter 6 im Select, sonst im Feld); 0 entfernt die Zeile.
//  - Escape im Feld: Server-Stand ohne Request — unter 6 zurueck aufs Select, sonst bleibt
//    das Feld mit der Menge des Servers. Das Escape endet hier (stopPropagation): im Drawer
//    schloesse es sonst zugleich den Drawer (Escape-Handler am document) — das naechste
//    Escape trifft ihn (Muster der Versand-Info-Blase, theme.js).
//  - Nach jedem Swap entscheidet Liquid nach item.quantity, welches Control sichtbar ist.
//  - Kein change-Handler am Feld — der feuerte schon beim Wechsel aufs Select.
//  - Warteschlange je Zeile (Block 1.5 des Warenkorb-Audits, C-2/R-6: letzte Eingabe
//    gewinnt): was waehrend eines laufenden Requests eingegeben
//    wird — Auswahl, Feld-Enter bzw. -Verlassen, Entfernen (absenden(key, 0) der Flaeche) —,
//    merkt sich vormerken() je Variante (der Zeilen-Key wechselt mit der Rabatt-Zuordnung);
//    eine spaetere Eingabe derselben Zeile ersetzt die fruehere. nachziehen() (die Flaeche ruft
//    es am Ende jedes Requests) schickt alle offenen Zeilen in EINEM update.js. Ein einziger
//    Nachzuegler-Platz fuer alle Zeilen verloere Feld-Enter und Entfernen still.
//  - Pfeiltasten auf dem geschlossenen Select (Audit A-15/A-17): Chrome und Firefox unter
//    Windows/Linux senden je Taste ein change — jede Zwischenmenge waere ein Request mit Ansage.
//    Kam das change von einer Navigationstaste (Pfeile, Pos1/Ende, Bild, Tipp-Auswahl), sendet
//    die Mengenwahl erst nach PAUSE_MS Ruhe; Enter oder Verlassen des Selects senden sofort.
//    Maus und Touch (Menue, Picker) senden sofort.
//  - Klemmung auf den Deckel (Audit A-10/R-7): die Meldung steht an der Zeile (zeilenFehler)
//    und wird angesagt — geht ein Request hinaus, vorne in der Ansage nach dem Swap
//    (klemmungNehmen -> cartSwapA11y.ansagen), sonst sofort in der Status-Region der Flaeche
//    (data-tpl-klemmung). Verlassen des Felds sendet nur, wenn sich der Wert geaendert hat: eine
//    Menge ueber dem Deckel klemmt nicht schon beim Durchtabben (sonst schickte Tab hinein und
//    hinaus still die geklemmte Menge).
// /cart/update.js klemmt NICHT: eine getippte 350 wird bei Bestand 14 mit HTTP 200
// uebernommen, und ein leeres Feld wuerde als 0 die Zeile
// kommentarlos loeschen. Beides klemmt deshalb der Client: Server-Wert = das gerenderte
// value-Attribut des Felds (input.defaultValue, ueberlebt Tippen und kommt mit jedem Swap
// frisch aus Liquid, patterns.md «Server-Stand eines Formularfelds»); data-max =
// min(Bestand, custom.max_bestellmenge), 0 = keine Grenze bekannt; die Regel selbst ist
// window.hdk.normalizeQty (assets/hdk-util.js, unit-getestet; Audit ROB-15:
// nur reine Ziffernfolgen, «1.5»/«3abc»/leer setzen still auf den Server-Wert zurueck,
// explizite 0 = Zeile entfernen).
// window.cartMengenwahl(wurzel, flaeche) bindet die Handler an eine Wurzel, die jeden Swap
// ueberlebt (Drawer-Body, .cart-page). flaeche.senden(updates) startet die Mutation mit einer
// Key-Map { key: menge } (die Flaeche sperrt, tauscht und gibt den Fokus zurueck),
// flaeche.busy() meldet einen laufenden Request, flaeche.status() liefert ihre Status-Region.
// Rueckgabe: absenden(key, menge) (sofort oder vorgemerkt), nachziehen() (Ende jedes Requests),
// verwerfen() (vor einem Neuladen), klemmungNehmen(key) (Ansage nach dem Swap),
// zuruecksetzen(key), dazu serverQty/mengeAusFeld/anwenden fuer das No-JS-Formular der Seite.
// Zuweisung an window statt const: alle Theme-Skripte teilen den globalen Scope.
// ============================================================
window.cartMengenwahl = (wurzel, flaeche) => {
  // Warteschlange und Klemmungen je Variante (Kopf des Blocks); Pausen je Select (A-15).
  const offen = new Map();
  const klemmungen = new Map();
  const pausen = new Map();
  const PAUSE_MS = 400;
  const NAVIGATION = new Set(['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown']);
  let tastenWahl = null;
  const variante = (key) => String(key).split(':')[0];

  const serverQty = (input) => {
    const v = parseInt(input.defaultValue, 10);
    return isNaN(v) ? 0 : v;
  };
  const mengeAusFeld = (input) => window.hdk.normalizeQty(input.value, serverQty(input), input.dataset.max);
  const titelZu = (el) => {
    const zeile = el.closest('.cart-item');
    const t = zeile && zeile.querySelector('.cart-item__title');
    return t ? t.textContent.trim() : '';
  };
  // Klemmung zeigen (Text serverseitig lokalisiert in data-max-msg, gleicher Slot wie at_max) und
  // fuer die Ansage merken; ohne folgenden Request sagt klemmungMelden sie sofort an.
  const klemmen = (el, feld, menge) => {
    window.hdkCart.zeilenFehler(wurzel, el.dataset.key, feld.dataset.maxMsg);
    klemmungen.set(variante(el.dataset.key), { text: feld.dataset.maxMsg, titel: titelZu(el), menge });
  };
  const klemmungMelden = (key) => {
    const k = klemmungen.get(variante(key));
    klemmungen.delete(variante(key));
    const region = flaeche.status && flaeche.status();
    if (!k || !region || !region.dataset.tplKlemmung) return;
    window.cartSwapA11y.melden(region, region.dataset.tplKlemmung.replace('__TITLE__', k.titel).replace('__MSG__', k.text).replace('__QTY__', k.menge));
  };
  // Normalisierten Wert ins Feld schreiben, bei Klemmung Meldung und Ansage vormerken.
  const anwenden = (input, q) => {
    input.value = q.value;
    if (q.clamped) klemmen(input, input, q.value);
  };
  // Sofort senden oder, waehrend ein Request laeuft, je Zeile vormerken (letzte Eingabe gewinnt).
  const absenden = (key, menge) => {
    if (!key) return;
    if (flaeche.busy()) { offen.set(variante(key), { key, menge }); return; }
    flaeche.senden({ [key]: menge });
  };
  const feldZu = (el) => { const g = el.closest('.cart-item__menge'); return g && g.querySelector('input.cart-item__qty-num'); };
  const auswahlZu = (el) => { const g = el.closest('.cart-item__menge'); return g && g.querySelector('select.cart-item__qty-select'); };
  // Groesste Zahl der Auswahl (data-liste, 5); darueber steht die Menge im Feld.
  const liste = (wahl) => parseInt(wahl.dataset.liste, 10) || 0;

  // Wechsel zwischen den beiden Controls derselben Box. Erst das neue einblenden (und, wenn
  // das alte den Fokus hatte, fokussieren), dann das alte ausblenden: der focusout des alten
  // sieht so sein Ziel in derselben Gruppe und sendet nichts, und ein ausgeblendetes Element
  // verliert den Fokus nie an <body>. disabled zum hidden: das ausgeblendete Control gehoert
  // nicht zum Formular (No-JS-Vertrag am Markup).
  function zeigeFeld(wahl, feld, wert) {
    feld.disabled = false;
    feld.hidden = false;
    feld.value = String(wert);
    feld.focus({ preventScroll: true });
    feld.select();
    wahl.hidden = true;
    wahl.disabled = true;
  }

  function zeigeAuswahl(wahl, feld, menge) {
    const hatteFokus = document.activeElement === feld;
    wahl.disabled = false;
    wahl.hidden = false;
    wahl.value = String(menge);
    if (hatteFokus) wahl.focus({ preventScroll: true });
    feld.hidden = true;
    feld.disabled = true;
  }

  // «6+»: aufs Feld wechseln, vorbelegt mit der ersten Menge ueber der Auswahl, hoechstens
  // dem Zeilen-Deckel (liegt er darunter, ist «6+» ohnehin gesperrt).
  function feldOeffnen(feld, wahl) {
    const ueber = liste(wahl) + 1;
    const max = parseInt(feld.dataset.max || '0', 10);
    zeigeFeld(wahl, feld, max > 0 ? Math.min(ueber, max) : ueber);
  }

  // Enter oder Verlassen des Felds. Eine gueltige Menge 1–5 zeigt vorher wieder das Select
  // mit dieser Zahl; leer/ungueltig steht nach anwenden auf dem Server-Wert und landet so
  // ebenfalls im passenden Control. 0 (Zeile entfernen) bleibt im Feld — die Zeile geht.
  function onInput(feld) {
    const q = mengeAusFeld(feld);
    anwenden(feld, q);
    const wahl = auswahlZu(feld);
    if (wahl && q.value >= 1 && q.value <= liste(wahl)) zeigeAuswahl(wahl, feld, q.value);
    // Leer/NaN: Feld steht wieder auf dem Server-Wert -> nichts zu senden. Auch nach einer
    // Klemmung kann der Wert dem Server-Stand entsprechen (Feld stand schon auf max) -> kein
    // Roundtrip, die Meldung steht bereits und wird jetzt angesagt.
    if (q.invalid || q.value === serverQty(feld)) { klemmungMelden(feld.dataset.key); return; }
    absenden(feld.dataset.key, q.value);
  }

  // Escape im Feld: verwerfen, Server-Stand zeigen, nichts senden.
  function onAbbruch(feld) {
    const server = serverQty(feld);
    feld.value = String(server);
    const wahl = auswahlZu(feld);
    if (wahl && server >= 1 && server <= liste(wahl)) zeigeAuswahl(wahl, feld, server);
    else feld.select();
  }

  function onAuswahl(wahl) {
    const feld = feldZu(wahl);
    if (!feld) return;
    const opt = wahl.options[wahl.selectedIndex];
    if (opt && opt.hasAttribute('data-mehr')) { pauseLoeschen(wahl); feldOeffnen(feld, wahl); return; }
    // Kam das change von einer Navigationstaste: erst nach der Pause senden (Kopf des Blocks).
    if (tastenWahl === wahl) {
      tastenWahl = null;
      pauseLoeschen(wahl);
      pausen.set(wahl, setTimeout(() => { pausen.delete(wahl); auswahlSenden(wahl); }, PAUSE_MS));
      return;
    }
    auswahlSenden(wahl);
  }

  function auswahlSenden(wahl) {
    const feld = feldZu(wahl);
    if (!feld) return;
    const q = window.hdk.normalizeQty(wahl.value, serverQty(feld), feld.dataset.max);
    if (q.clamped) klemmen(wahl, feld, q.value);
    if (q.invalid || q.value === serverQty(feld)) { wahl.value = String(serverQty(feld)); klemmungMelden(wahl.dataset.key); return; }
    absenden(wahl.dataset.key, q.value);
  }

  function pauseLoeschen(wahl) {
    clearTimeout(pausen.get(wahl));
    pausen.delete(wahl);
  }
  // Wartende Tastatur-Auswahl sofort senden (Enter, Verlassen des Selects).
  function pauseBeenden(wahl) {
    if (!pausen.has(wahl)) return;
    pauseLoeschen(wahl);
    auswahlSenden(wahl);
  }

  wurzel.addEventListener('change', (e) => {
    const wahl = e.target.closest('select.cart-item__qty-select');
    if (wahl) onAuswahl(wahl);
  });

  // Herkunft des naechsten change merken: Navigationstaste (Pause) oder Zeiger (sofort).
  wurzel.addEventListener('pointerdown', () => { tastenWahl = null; }, true);
  wurzel.addEventListener('keydown', (e) => {
    const wahl = e.target.closest('select.cart-item__qty-select');
    if (!wahl) return;
    if (e.key === 'Enter') { tastenWahl = null; pauseBeenden(wahl); return; }
    // Tipp-Auswahl (Ziffer waehlt die Option), aber nicht die Leertaste: sie oeffnet das Menue.
    const tippen = e.key.length === 1 && e.key !== ' ' && !e.ctrlKey && !e.metaKey && !e.altKey;
    tastenWahl = NAVIGATION.has(e.key) || tippen ? wahl : null;
  });

  wurzel.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== 'Escape') return;
    const feld = e.target.closest('.cart-item__menge input.cart-item__qty-num');
    if (!feld) return;
    // Kein natives Absenden: das Formular der Seite hat mit JavaScript keinen Absende-Knopf
    // (und mehrere Textfelder sperren das implizite Absenden ohnehin), der Drawer steht in
    // keinem Formular.
    e.preventDefault();
    if (e.key === 'Escape') { e.stopPropagation(); onAbbruch(feld); }
    else onInput(feld);
  });

  wurzel.addEventListener('focusout', (e) => {
    const gruppe = e.target.closest('.cart-item__menge');
    if (!gruppe || (e.relatedTarget && gruppe.contains(e.relatedTarget))) return;
    // Verlassen des Selects: eine wartende Tastatur-Auswahl jetzt senden (A-15).
    const wahl = gruppe.querySelector('select.cart-item__qty-select');
    if (wahl && e.target === wahl) setTimeout(() => pauseBeenden(wahl), 0);
    const feld = gruppe.querySelector('input.cart-item__qty-num');
    if (!feld || feld.hidden) return;
    // Nur eine geaenderte Eingabe senden (R-7): Durchtabben einer Menge ueber dem Deckel
    // klemmt nicht still. Erst nach dem Fokuswechsel: cartSwapA11y.vorher sieht dann das neue
    // Ziel (z. B. das Entfernen derselben Zeile) und gibt ihm nach dem Swap sein Gegenstueck —
    // im focusout selbst steht der Fokus noch auf <body>. Ist das Feld bis dahin zu
    // (Escape), gibt es nichts zu senden.
    if (feld.value.trim() === feld.defaultValue) return;
    setTimeout(() => { if (feld.isConnected && !feld.hidden) onInput(feld); }, 0);
  });

  return {
    serverQty,
    mengeAusFeld,
    anwenden,
    absenden,
    // Vor einem Neuladen bzw. nach einem Netz-/Serverfehler: nichts mehr nachsenden.
    verwerfen() {
      offen.clear();
      klemmungen.clear();
      pausen.forEach((uhr) => clearTimeout(uhr));
      pausen.clear();
    },
    // Fuer die Ansage nach dem Swap (cartSwapA11y.ansagen, info.klemmung): der Grund, falls die
    // gesendete Menge dieser Zeile geklemmt wurde.
    klemmungNehmen(key) {
      const k = klemmungen.get(variante(key));
      klemmungen.delete(variante(key));
      return k ? k.text : '';
    },
    // Nach einem Netz- oder Serverfehler (hdkCart, art 'netz'/'server'; Block 0.5): die Zeile
    // zeigt wieder den Server-Stand — es gab keinen Swap, Select bzw. Feld stehen noch auf der
    // gewaehlten, nie gespeicherten Menge. Server-Wert = defaultValue des Felds (Kommentar oben).
    // Unter 6 die Auswahl, ab 6 das Feld, wie Liquid es rendert. Der Fokus bleibt beim Control
    // der Zeile: lag er auf dem, das jetzt verschwindet, geht er aufs Gegenstueck derselben Box.
    zuruecksetzen(key) {
      const zeile = window.cartSwapA11y.zeile(wurzel, key);
      const feld = zeile && zeile.querySelector('input.cart-item__qty-num');
      const wahl = zeile && zeile.querySelector('select.cart-item__qty-select');
      if (!feld || !wahl) return;
      const server = serverQty(feld);
      feld.value = String(server);
      if (server >= 1 && server <= liste(wahl)) {
        zeigeAuswahl(wahl, feld, server);
      } else if (server > liste(wahl) && feld.hidden) {
        const hatteFokus = document.activeElement === wahl;
        feld.disabled = false;
        feld.hidden = false;
        if (hatteFokus) feld.focus({ preventScroll: true });
        wahl.hidden = true;
        wahl.disabled = true;
      }
    },
    // Ende jedes Requests: die vorgemerkten Zeilen in EINEM update.js nachsenden (Warteschlange,
    // Kopf des Blocks). Der Zeilen-Key kann sich geaendert haben (Dealeasy-Staffel: neue
    // Rabatt-Zuordnung = neuer Key) — die Zeile findet cartSwapA11y.zeile ueber die
    // Varianten-ID. Ist sie weg oder steht schon auf der Menge, entfaellt der Eintrag. Die
    // Auswahl zeigt die vorgemerkte Menge bis zur Antwort; zeigt die Zeile das Feld (ab 6),
    // bleibt sie so — der naechste Swap zeigt das passende Control.
    nachziehen() {
      if (!offen.size) return;
      const updates = {};
      offen.forEach(({ key, menge }) => {
        const zeile = window.cartSwapA11y.zeile(wurzel, key);
        const feld = zeile && zeile.querySelector('input.cart-item__qty-num');
        if (!feld || menge === serverQty(feld)) return;
        const wahl = zeile.querySelector('select.cart-item__qty-select');
        if (wahl && !wahl.hidden && menge >= 1 && menge <= liste(wahl)) wahl.value = String(menge);
        updates[zeile.dataset.key] = menge;
      });
      offen.clear();
      if (Object.keys(updates).length) flaeche.senden(updates);
    },
  };
};

// ============================================================
// Mehr-Dialog (#cart-mehr) — EINE Implementierung fuer Drawer und /cart: weitere
// Warenkorbfueller bzw. alle ergaenzenden Produkte zeigen, ohne die Flaeche zu verlassen —
// Produktkarten mit Kaufknopf in einem Dialog. Auf /cart aus Fueller- und Cross-Selling-Block,
// im Drawer aus Fueller-Streifen und Seitenpanel. Die Shell steht EINMAL pro Seite in
// snippets/cart-mehr-dialog.liquid (gerendert im Drawer-Section), Optik in cart-drawer.css.
//  - Ausloeser: der Fueller-Link «Weitere Warenkorbfueller ansehen» (ohne JS der Weg zur
//    Kollektion) wird zum Knopf, der Cross-Selling-Knopf der Seite (ohne JS ohne Ziel, darum
//    `hidden`) wird eingeblendet — ausloeser(wurzel) auf jedem frischen Markup (Seite: beim
//    Laden und in swap() auf dem geparsten Dokument; Drawer: beim Start und in swapContent).
//    Den Klick delegiert jede Flaeche an ihrer stabilen Wurzel und ruft oeffnen().
//  - Dialog: natives <dialog> mit showModal(). Der Browser legt ihn in den Top-Layer (ueber
//    Drawer und Overlay, ohne z-index) und macht den Rest der Seite inert; Escape schliesst
//    ueber einen eigenen Handler (Pandectes unterdrueckt das native Schliessen, Kommentar
//    dort) und NUR den Dialog, Hintergrund-Klick ueber closedby="any" bzw. den Klick-Handler
//    unten. Eine Tab-FALLE hat der native Dialog nicht: am letzten bzw. ersten Element
//    verlaesst der Fokus den Dialog Richtung Browser-Oberflaeche (Shift+Tab vom
//    Schliessen-Knopf landet auf <body>). Das zyklische Tab kommt
//    darum wie bei Drawer und Lightbox aus window.modalFocus (theme.js) — EINE Falle, die
//    native Inertheit ist keine zweite. Ueber dem offenen Drawer stapelt modalFocus die Falle
//    (activate mit { ueber: true }): beim Schliessen gilt wieder die des
//    Drawers. modalFocus setzt auch den Container-Fokus beim Oeffnen (Lektion 1
//    «Fokus-Management fuer modale Panels»). Beim Schliessen geht der Fokus auf den Ausloeser —
//    selbst gesucht (deactivate ohne restore): die native wie die modalFocus-Rueckgabe traefen
//    nach einem Kauf den alten, per Swap abgehaengten Knoten.
//    Body-Scroll-Sperre per Attribut scroll-lock (critical.css), kein JS-Zustand.
//  - Inhalt: erst beim Oeffnen per Section Rendering (/?sections=cart-mehr-<art>), bei
//    jedem Oeffnen frisch (ohne die inzwischen gekauften Artikel). Ueberholte Antworten
//    (Dialog zu oder neu geoeffnet) verwirft der Zaehler abruf.
//  - Kauf: flaeche.kaufen(variantId) — die Flaeche kauft ueber hdkCart.add mit stattDrawer
//    (Seite: Sections 'main-cart', Swap; Drawer: Drawer-Sections, applySections — der Drawer
//    aktualisiert sich hinter dem Dialog, Zaehler und andere Flaechen per cart:updated). Der
//    Dialog bleibt offen und wird NICHT neu geladen (Fokus und Scrollposition bleiben). Knopf:
//    Ladepunkte, 2 s «Hinzugefuegt» mit Haken, dann «Im Warenkorb»; gesperrt per aria-disabled
//    (ein disabled-Knopf verloere den Fokus). Mehrere Varianten: die Wahl im <select>
//    entscheidet, eine andere Variante macht den Knopf wieder frei. Kaeufe laufen nacheinander
//    (kette): parallele Antworten kaemen in beliebiger Reihenfolge, ein aelterer Stand
//    ueberschriebe den neueren. Abgelehnt: die Flaeche laedt den Server-Stand (Shopify bucht
//    bei 422 ein, was verfuegbar ist), der Kundentext aus hdkCart.addMeldung (Shopifys
//    Mengenmeldung oder eigener Text je Fehlerklasse) bzw. cart.filler_error unter dem Knopf.
//  - Ansage (Titel, Menge, Total wie beim Fueller-Plus) in der Status-Region IM Dialog: die
//    Regionen der Flaechen liegen im inerten Teil, Screenreader hoerten sie nicht. Ist der
//    Dialog beim Eintreffen der Antwort schon zu, die Region der Flaeche.
//  - Ausschluss: der Dialog zeigt nur zusaetzliche Artikel — was die Flaeche schon zeigt,
//    faellt nach dem Abruf aus dem Raster — die IDs
//    tragen ihre Bloecke als data-produkt-ids (',id,id,', dieselbe Liste, die ihre Auswahl
//    ergab; auf der Seite Fueller- UND Cross-Selling-Block — der Fueller zeigt zuerst Artikel,
//    die auch im Cross-Selling stuenden, und das Cross-Selling kann Fueller-Artikel zeigen;
//    im Drawer der Fueller-Block). In JS, weil /?sections= keine Parameter traegt. Ein
//    Schalter je Dialog (MEHR_AUSSCHLUSS): soll der Ausschluss zurueck (kleine Warenkoerbe:
//    wenige Kandidaten), hier false. Ob der Ausloeser ueberhaupt erscheint,
//    entscheidet Liquid (mehr Artikel als der Block zeigt, snippets/cart-filler.liquid bzw.
//    cart-cross-sell.liquid); bleibt nach dem Ausschluss nichts, steht die Leer-Meldung da.
// window.cartMehr.oeffnen(art, flaeche) mit art 'fueller' | 'crosssell' und flaeche = {
//   wurzel        stabile Wurzel der Flaeche: ihre Bloecke (data-produkt-ids, Ausschluss) und
//                 der Ausloeser derselben Art, der nach dem Schliessen den Fokus bekommt (nach
//                 einem Kauf ein neuer Knoten — darum per Selektor gesucht)
//   kaufen(id)    -> Promise<{ ok, meldung, container, totalEl } | { neuGeladen: true }>
//   ersatz()      Fokus-Ersatz ohne Ausloeser (Seite: die h1; Drawer: der Drawer selbst)
//   statusId      Status-Region der Flaeche (Ansage, wenn der Dialog schon zu ist)
// }
// Zuweisung an window statt const: alle Theme-Skripte teilen den globalen Scope.
// ============================================================
window.cartMehr = (() => {
  const MEHR_AUSSCHLUSS = { fueller: true, crosssell: true };
  let mehr = null;
  let bereit = false;
  let flaeche = null;
  let art = '';
  let abruf = 0;
  let kette = Promise.resolve();
  let unten = false;
  const uhren = new WeakMap();

  const dialog = () => {
    if (!mehr) mehr = document.getElementById('cart-mehr');
    return mehr;
  };
  const moeglich = () => !!(dialog() && typeof mehr.showModal === 'function');

  function zustand(z) {
    mehr.querySelector('.cart-mehr__laden').hidden = z !== 'laden';
    mehr.querySelector('[data-mehr-fehler]').hidden = z !== 'fehler';
    mehr.querySelector('[data-mehr-leer]').hidden = z !== 'leer';
  }

  // Fokus nach dem Schliessen: der Ausloeser derselben Art (nach einem Kauf ein neuer Knoten),
  // fehlt er (Block nach dem Kauf weg: Gratisgrenze erreicht, keine Kandidaten mehr), der Ersatz
  // der Flaeche. preventScroll und hoechstens minimal nachscrollen: die Seite steht nach dem
  // Schliessen, wo sie war.
  function fokusZurueck() {
    if (!flaeche) return;
    let ziel = flaeche.wurzel ? flaeche.wurzel.querySelector('button[data-cart-mehr="' + art + '"]') : null;
    if (!ziel) ziel = flaeche.ersatz();
    if (!ziel) return;
    ziel.focus({ preventScroll: true });
    const box = ziel.getBoundingClientRect();
    if (box.bottom < 0 || box.top > window.innerHeight) ziel.scrollIntoView({ block: 'nearest' });
  }

  // Hintergrund-Klick: der ::backdrop meldet sich als Klick auf den Dialog selbst — nur
  // ausserhalb der Box schliessen, und nur, wenn auch der Druck dort begann (ein Markieren,
  // das in der Box beginnt und draussen endet, schliesst nicht).
  function ausserhalb(e) {
    const box = mehr.getBoundingClientRect();
    return e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom;
  }

  // Knopf-Zustaende: 'normal' | 'laden' | 'hinzugefuegt' | 'im-warenkorb'
  function knopfZustand(knopf, z) {
    const text = knopf.querySelector('.cart-mehr__add-text');
    if (!text) return;
    if (knopf.dataset.tNormal === undefined) knopf.dataset.tNormal = text.textContent;
    knopf.classList.toggle('is-laden', z === 'laden');
    knopf.classList.toggle('is-hinzugefuegt', z === 'hinzugefuegt');
    knopf.classList.toggle('is-im-warenkorb', z === 'im-warenkorb');
    if (z === 'normal') knopf.removeAttribute('aria-disabled');
    else knopf.setAttribute('aria-disabled', 'true');
    let punkte = knopf.querySelector('.cart-mehr__add-punkte');
    if (z === 'laden' && !punkte) {
      punkte = document.createElement('span');
      punkte.className = 'cart-mehr__add-punkte';
      punkte.setAttribute('aria-hidden', 'true');
      punkte.append(document.createElement('span'), document.createElement('span'), document.createElement('span'));
      knopf.appendChild(punkte);
    } else if (z !== 'laden' && punkte) {
      punkte.remove();
    }
    const mitHaken = z === 'hinzugefuegt' || z === 'im-warenkorb';
    const haken = knopf.querySelector('.cart-mehr__add-haken');
    if (mitHaken && !haken) {
      // Eigenes, statisches Markup (kein Fremdtext)
      knopf.insertAdjacentHTML('afterbegin', '<svg class="cart-mehr__add-haken" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>');
    } else if (!mitHaken && haken) {
      haken.remove();
    }
    text.textContent = z === 'hinzugefuegt' ? (mehr.dataset.tAdded || '')
      : z === 'im-warenkorb' ? (mehr.dataset.tInCart || '')
      : knopf.dataset.tNormal;
  }

  // Zustand des Knopfs nach der Variantenwahl: liegt die gewaehlte Variante schon (aus
  // diesem Dialog) im Warenkorb, «Im Warenkorb», sonst wieder kaufbar.
  function wahlZustand(eintrag) {
    const knopf = eintrag.querySelector('.cart-mehr__add');
    if (!knopf || knopf.classList.contains('is-laden')) return;
    clearTimeout(uhren.get(knopf));
    const wahl = eintrag.querySelector('.cart-mehr__variante');
    const id = wahl ? wahl.value : knopf.dataset.variantId;
    const drin = (eintrag.dataset.imWarenkorb || '').indexOf(',' + id + ',') !== -1;
    knopfZustand(knopf, drin ? 'im-warenkorb' : 'normal');
  }

  function kaufen(knopf) {
    if (knopf.getAttribute('aria-disabled') === 'true' || !flaeche) return;
    const eintrag = knopf.closest('.cart-mehr__item');
    const wahl = eintrag && eintrag.querySelector('.cart-mehr__variante');
    const variantId = wahl ? wahl.value : knopf.dataset.variantId;
    if (!eintrag || !variantId) return;
    const alt = eintrag.querySelector('.cart-mehr__error');
    if (alt) alt.remove();
    knopfZustand(knopf, 'laden');
    const f = flaeche;
    kette = kette
      .then(() => kaufAusfuehren(f, knopf, eintrag, variantId))
      .catch((err) => console.error('Mehr-Dialog: Kauf fehlgeschlagen', err));
  }

  async function kaufAusfuehren(f, knopf, eintrag, variantId) {
    const titelEl = eintrag.querySelector('.product-card__title');
    // Zeilen-Key ist «<variant>:<hash>» — cartSwapA11y findet die Position ueber das Praefix.
    const info = { key: variantId + ':', titel: titelEl ? titelEl.textContent.trim() : '' };
    const ergebnis = await f.kaufen(variantId);
    if (!ergebnis || ergebnis.neuGeladen) return;
    if (ergebnis.ok) {
      eintrag.dataset.imWarenkorb = (eintrag.dataset.imWarenkorb || ',') + variantId + ',';
      knopfZustand(knopf, 'hinzugefuegt');
      clearTimeout(uhren.get(knopf));
      uhren.set(knopf, setTimeout(() => wahlZustand(eintrag), 2000));
      const region = document.getElementById(mehr.open ? 'cart-mehr-status' : f.statusId);
      window.cartSwapA11y.ansagen(region, ergebnis.container, info, ergebnis.totalEl);
    } else {
      knopfZustand(knopf, 'normal');
      const meldung = document.createElement('p');
      meldung.className = 'cart-mehr__error';
      meldung.setAttribute('role', 'alert');
      meldung.textContent = ergebnis.meldung || window.themeStrings.fillerError || '';
      (eintrag.querySelector('.cart-mehr__kauf') || eintrag).appendChild(meldung);
    }
    // Dialog waehrend des Kaufs geschlossen: der Swap hat den fokussierten Ausloeser ersetzt.
    if (!mehr.open && (document.activeElement === document.body || !document.activeElement)) fokusZurueck();
  }

  // Handler EINMAL am Dialog (die Shell ueberlebt jeden Swap beider Flaechen).
  function binden() {
    if (bereit || !moeglich()) return;
    bereit = true;
    // Escape selbst behandeln statt dem nativen cancel zu vertrauen: VENDOR:pandectes-escape —
    // der Cookie-Banner (Pandectes-Core) ruft am document bei JEDEM Escape preventDefault(),
    // solange sein Dialog aktiv ist (Erstbesuch vor der Einwilligung), und das unterdrueckt
    // das native Schliessen (pandectes-core-latest.js). Eine
    // Einwilligung loest Escape dort NICHT aus: «dismiss» (das layout/theme.liquid zur
    // Einwilligung macht, VENDOR:pandectes-close-action) feuert der Core nur, wenn Escape als
    // Schliess-Trigger konfiguriert ist — im Shop ist es nur der Knopf (close.triggers
    // ['button'], docs/cookie-consent.md). stopPropagation trotzdem: ein
    // Escape, das den obersten Dialog schliessen soll, hat am Banner dahinter nichts zu suchen,
    // auch falls der Trigger je eingeschaltet wird. Derselbe
    // Stopp haelt den Escape-Handler des Drawers (am document) still: Escape schliesst nur
    // den Dialog, der Drawer dahinter bleibt offen.
    mehr.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !mehr.open) return;
      e.preventDefault();
      e.stopPropagation();
      mehr.close();
    });
    mehr.addEventListener('pointerdown', (e) => { unten = e.target === mehr && ausserhalb(e); });
    mehr.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-mehr-schliessen]')) { mehr.close(); return; }
      const knopf = e.target.closest('.cart-mehr__add');
      if (knopf) { kaufen(knopf); return; }
      if (e.target === mehr && unten && ausserhalb(e) && mehr.open) mehr.close();
    });
    // Variantenwahl: Knopf-Zustand und Kartenbild der gewaehlten Variante. Das Bild der
    // Variante steht an der
    // <option> (data-variant-image, snippets/cart-mehr-karte.liquid); ohne eigenes Bild gilt
    // wieder das Bild aus dem Markup. Getauscht wird das RUHEbild (window.hdkKartenBild,
    // theme.js — dieselbe Regel wie der Karten-Hover, src + srcset): der 2.-Bild-Hover kehrt
    // danach zur gewaehlten Variante zurueck, nicht zum Hauptbild.
    mehr.addEventListener('change', (e) => {
      const wahl = e.target.closest('.cart-mehr__variante');
      const eintrag = wahl && wahl.closest('.cart-mehr__item');
      if (!eintrag) return;
      wahlZustand(eintrag);
      const img = eintrag.querySelector('.product-card__image');
      const opt = wahl.options[wahl.selectedIndex];
      if (img && opt && window.hdkKartenBild) window.hdkKartenBild.ruhebild(img, opt.dataset.variantImage || '');
    });
    mehr.addEventListener('close', () => {
      abruf++;
      // Falle loesen; lag der Dialog ueber dem Drawer, gilt wieder dessen Falle (theme.js).
      if (window.modalFocus) window.modalFocus.deactivate({ restore: false });
      mehr.querySelector('.cart-mehr__inhalt').replaceChildren();
      zustand(null);
      fokusZurueck();
    });
  }

  return {
    // Ausloeser freischalten (Link -> Knopf, hidden-Knopf einblenden), auf frischem Markup
    // vor dem Einhaengen — sonst blitzte der Link auf. Ohne showModal bleibt der Link.
    ausloeser(wurzel) {
      if (!wurzel || !moeglich()) return;
      wurzel.querySelectorAll('a[data-cart-mehr]').forEach((link) => {
        const knopf = link.ownerDocument.createElement('button');
        knopf.type = 'button';
        knopf.className = link.className;
        knopf.dataset.cartMehr = link.dataset.cartMehr;
        knopf.setAttribute('aria-haspopup', 'dialog');
        knopf.append(...link.childNodes);
        link.replaceWith(knopf);
      });
      wurzel.querySelectorAll('button[data-cart-mehr][hidden]').forEach((knopf) => { knopf.hidden = false; });
    },

    async oeffnen(a, f) {
      if (!moeglich() || mehr.open) return;
      binden();
      art = a;
      flaeche = f;
      mehr.querySelector('.cart-mehr__title').textContent =
        (a === 'crosssell' ? mehr.dataset.titelCrosssell : mehr.dataset.titelFueller) || '';
      const inhalt = mehr.querySelector('.cart-mehr__inhalt');
      inhalt.replaceChildren();
      zustand('laden');
      mehr.querySelector('.cart-mehr__body').scrollTop = 0;
      mehr.showModal();
      if (window.modalFocus) window.modalFocus.activate(mehr, { ueber: true });
      else mehr.focus({ preventScroll: true });
      const nr = ++abruf;
      let raster = null;
      try {
        const res = await fetch(window.routes.root + '?sections=cart-mehr-' + a);
        const daten = res.ok ? await res.json() : null;
        const html = daten && daten['cart-mehr-' + a];
        if (html) raster = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-mehr__grid');
      } catch (err) {
        raster = null;
      }
      if (nr !== abruf || !mehr.open) return;
      if (!raster) { zustand('fehler'); return; }
      if (MEHR_AUSSCHLUSS[a] && f.wurzel) {
        let gezeigt = ',';
        f.wurzel.querySelectorAll('[data-produkt-ids]').forEach((block) => { gezeigt += block.dataset.produktIds.slice(1); });
        raster.querySelectorAll('.cart-mehr__item[data-produkt-id]').forEach((eintrag) => {
          if (gezeigt.indexOf(',' + eintrag.dataset.produktId + ',') !== -1) eintrag.remove();
        });
      }
      if (!raster.children.length) { zustand('leer'); return; }
      // Keine Badge-Lokalisierung: die Karten tragen die Bewertungszeile des Themes
      // (product-card mit eigene_sterne, Audit Warenkorb P-2) statt Judge.mes Badge.
      zustand(null);
      inhalt.appendChild(raster);
    },

    // Fuer die Zurueck-Taste des Drawers (CartDrawer.verlaufBinden): liegt der Dialog oben,
    // schliesst die Zurueck-Taste zuerst ihn.
    offen: () => !!(dialog() && mehr.open),
    schliessen() { if (dialog() && mehr.open) mehr.close(); },
  };
})();

const CartDrawer = {

  drawer:   null,
  overlay:  null,
  body:     null,
  footer:   null,
  notice:   null,
  _busy:    false,
  // Gestartete Mutationen (Sequenz-Schutz, refreshFromServer) und «cart:updated kam waehrend
  // einer Mutation» (freigeben holt nach).
  _mutationen: 0,
  _nachholen: false,
  _selfEvent: false,
  _bodyVorLaden: null,
  // Frisch halten (abgleichen() unten): Zeitpunkt des letzten Server-Stands,
  // Zaehler der angewendeten Staende (erkennt eine Mutation waehrend eines
  // Hintergrund-Abrufs) und Sperre gegen parallele Abgleiche.
  ABGLEICH_PAUSE_MS: 30000,
  _letzterAbgleich: 0,
  _stand: 0,
  _abgleichLaeuft: false,
  // Zurueck-Taste im Vollbild (verlaufBinden unten): Breitenabfrage, «ein eigener
  // Verlaufseintrag steht fuer den offenen Drawer», «das naechste popstate hat close()
  // selbst ausgeloest» und «der laufende Klick gilt einem Link» (Navigation).
  _vollbild: null,
  _verlauf: false,
  _verlaufZurueck: false,
  _linkKlick: false,

  init() {
    this.drawer  = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    this.body    = document.getElementById('cart-drawer-body');
    this.footer  = document.getElementById('cart-drawer-footer');
    this.notice  = document.getElementById('cart-drawer-notice');

    if (!this.drawer) return;

    document.getElementById('cart-drawer-close')?.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', () => this.close());
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });

    const warenkorbKnopf = document.querySelector('.header__cart-btn');
    warenkorbKnopf?.addEventListener('click', (e) => {
      e.preventDefault();
      this.open();
    });
    // Absicht zu oeffnen (Zeiger ueber dem Knopf, Tastaturfokus, Beruehrung): Bilder schon
    // freigeben, damit sie laden, bevor das Panel einfaehrt (vorbereiten, P-5).
    ['pointerenter', 'focus', 'touchstart'].forEach((typ) => {
      warenkorbKnopf?.addEventListener(typ, () => this.vorbereiten(), { once: true, passive: true });
    });

    // Event-Delegation auf dem Body -> ueberlebt das Austauschen des Inhalts nach Mutationen
    // Entfernen ist derselbe Link wie auf /cart (url_to_remove als No-JS-Weg) —
    // mit JavaScript bleibt der Drawer offen: kein Seitenwechsel, Menge 0 ueber hdkCart.
    this.body.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('.cart-item__remove');
      if (removeBtn) { e.preventDefault(); this.onRemoveClick(removeBtn); }
    });
    // Mengenwahl (Auswahl 1–5 / «6+», ab 6 das Feld): dieselbe Implementierung wie /cart
    // (window.cartMengenwahl oben), gebunden am Body.
    this.mengenwahl = window.cartMengenwahl(this.body, {
      senden: (updates) => this.sendUpdate(updates),
      busy: () => this._busy,
      status: () => document.getElementById('cart-drawer-status'),
    });

    // Warenkorbfueller (snippets/cart-filler.liquid) sitzt im FOOTER, nicht im Body —
    // die Delegation haengt darum am Drawer-Root, der als einziger Knoten jeden
    // Sections-API-Swap ueberlebt (Body-innerHTML und Footer-Knoten werden ersetzt).
    this.drawer.addEventListener('click', (e) => {
      // Ausloeser des Mehr-Dialogs («Weitere Warenkorbfueller ansehen»)
      const mehrBtn = e.target.closest('button[data-cart-mehr]');
      if (mehrBtn) { this.mehrOeffnen(mehrBtn.dataset.cartMehr); return; }
      const fillerBtn = e.target.closest('.cart-filler__add[data-variant-id]');
      if (fillerBtn) this.onFillerAdd(fillerBtn);
    });
    window.cartMehr.ausloeser(this.footer);
    window.cartStreifenFokus(this.drawer);
    this.bindFillerDrag();
    this.panelKantenBinden();
    this.rabattBinden();

    // Fremdaenderung am Cart (z.B. /cart-Seite) -> Drawer silent im Hintergrund frisch halten.
    // _selfEvent verhindert Reaktion auf die eigene Mutation (kein Endlos-Sync).
    // Traegt das Event die Drawer-Sections schon (detail.sections['cart-drawer'] — /cart bestellt
    // sie mit jeder Mutation mit, Audit Warenkorb P-3), nimmt der Drawer sie direkt:
    // kein zweiter Abruf und kein zweiter Server-Render je Mengenaenderung, derselbe Stand.
    // Laeuft gerade eine eigene Mutation, wird nachgeholt, wenn sie fertig ist (freigeben);
    // ein Abruf, den eine Mutation ueberholt, wird verworfen (refreshFromServer mit
    // verwerfbar, Audit R-4).
    document.addEventListener('cart:updated', (e) => {
      if (this._selfEvent) return;
      if (this._busy) { this._nachholen = true; return; }
      const sections = e.detail && e.detail.sections;
      if (sections && sections['cart-drawer']) {
        this.applySections(sections, e.detail, true);
        return;
      }
      this.refreshFromServer(true, true);
    });

    // Das Seiten-HTML ist der erste Server-Stand.
    this._letzterAbgleich = Date.now();
    this.frischHaltenBinden();
    this.verlaufBinden();
  },

  // --- Zurueck-Taste schliesst den Vollbild-Drawer -------
  // Unter 600 px ersetzt der Drawer die Seite (Vollbild, cart-drawer.css); die Zurueck-Taste
  // (Browser, Android-System, iOS-Wischgeste) verliesse sonst die ganze Seite.
  // Darum legt das Oeffnen unter 600 px einen eigenen Verlaufseintrag an: pushState auf
  // dieselbe URL mit dem Zustand { cartDrawer: true } (verlaufSetzen, aus showPanel). Ab 600
  // (Panel neben der Seite) kein Eintrag — dort ist die Seite sichtbar, Zurueck verlaesst sie.
  //  - Zurueck-Taste: popstate nimmt den Eintrag weg, der Drawer schliesst — ohne selbst
  //    zurueckzugehen. Liegt der Mehr-Dialog oben, schliesst sie zuerst ihn und setzt den
  //    Eintrag neu (der Drawer bleibt offen, das naechste Zurueck schliesst ihn).
  //  - Schliessen per ×, Escape oder Overlay: close() nimmt den Eintrag per history.back()
  //    weg; das folgende popstate gehoert dem Drawer (_verlaufZurueck) und tut nichts.
  //  - Ein Link im Drawer navigiert (Titel, «Zum Warenkorb», «Zur Kasse», Fueller-Titel):
  //    der Eintrag bleibt und steht fuer «Drawer offen». Kommt die Seite damit zurueck
  //    (Zurueck-Taste, bfcache) oder fuehrt Vorwaerts wieder auf ihn, ist der Drawer wieder
  //    offen (verlaufWiederherstellen) — das naechste Zurueck schliesst ihn. Neu laden auf dem
  //    Eintrag oeffnet ihn nicht (Block 1.8, unten).
  //    Ruft der Link selbst close() («Weiter shoppen» im Leer-Zustand), waere history.back()
  //    ein Wettlauf mit der Navigation: dann wird der Eintrag nur neutralisiert (replaceState).
  //  - Breitenwechsel bei offenem Drawer (Drehen): ueber die Schwelle nach unten setzt den
  //    Eintrag nach; nach oben bleibt er — Zurueck schliesst dann auch das Panel, harmlos.
  //  - popstate des Drawers endet hier (stopImmediatePropagation): die URL ist dieselbe,
  //    filter.js (Kollektion, Suche) laedt sonst bei jedem popstate das Raster neu. Unser
  //    Listener steht vor dem von filter.js (cart-drawer.js laedt und initialisiert zuerst).
  // Abfrage max-width nur hier im JS (die CSS-Weiche ist mobile-first min-width: 600px);
  // 599px = die Grenze des Vollbilds.
  verlaufBinden() {
    if (!window.history || typeof history.pushState !== 'function' || !window.matchMedia) return;
    this._vollbild = window.matchMedia('(max-width: 599px)');
    // Ein Drawer-Eintrag oeffnet den Drawer beim Laden NUR, wenn die Seite aus dem Verlauf kommt
    // (navigation.type 'back_forward'; bfcache-Restores laufen ohne neues Laden ueber pageshow).
    // Jede andere Ladeart neutralisiert ihn (replaceState), der Drawer startet geschlossen:
    //  - 'reload' (Block 1.8 des Warenkorb-Audits, C-9, Punkt 34): wer neu laedt, will die Seite;
    //  - 'navigate' auf dieselbe URL (z. B. auf /cart im Drawer «Zum Warenkorb»): der Browser
    //    macht aus einer Navigation auf die URL des aktuellen Eintrags ein Ersetzen und behaelt
    //    dessen history.state ({cartDrawer: true}, type 'navigate') — ohne diese Regel ginge der
    //    Drawer nach dem Laden sofort wieder auf. Ein Link aus dem Drawer darf auf der Zielseite
    //    nie einen offenen Drawer ergeben.
    // Der Preis: danach bleibt eine Zurueck-Taste auf derselben URL ohne sichtbare Wirkung (ein
    // history.back() beim Laden waere ein Wettlauf mit der Navigation). Zurueck-Taste, bfcache und
    // Vorwaerts oeffnen ihn weiter (verlaufWiederherstellen, 2026-10-26 (1)).
    const laden = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (laden && laden.type !== 'back_forward' && history.state && history.state.cartDrawer) history.replaceState(null, '');
    // Klick auf einen Link im Drawer: Capture-Phase, laeuft vor dessen eigenem onclick.
    this.drawer.addEventListener('click', (e) => {
      if (!e.target.closest('a[href]')) return;
      this._linkKlick = true;
      setTimeout(() => { this._linkKlick = false; }, 0);
    }, true);
    window.addEventListener('popstate', (e) => {
      if (this._verlaufZurueck) {
        this._verlaufZurueck = false;
        e.stopImmediatePropagation();
        return;
      }
      if (this._verlauf) {
        e.stopImmediatePropagation();
        if (window.cartMehr && window.cartMehr.offen()) {
          window.cartMehr.schliessen();
          history.pushState({ cartDrawer: true }, '');
          return;
        }
        this._verlauf = false;
        this.close();
        return;
      }
      if (e.state && e.state.cartDrawer) {
        e.stopImmediatePropagation();
        this.verlaufWiederherstellen();
      }
    });
    this._vollbild.addEventListener('change', () => {
      if (this._vollbild.matches && this.drawer.classList.contains('cart-drawer--open')) this.verlaufSetzen();
    });
    window.addEventListener('pageshow', () => this.verlaufWiederherstellen());
  },

  verlaufSetzen() {
    if (this._verlauf || !this._vollbild || !this._vollbild.matches) return;
    history.pushState({ cartDrawer: true }, '');
    this._verlauf = true;
  },

  // Die Seite steht auf einem Drawer-Eintrag (zurueck auf die Seite, Vorwaerts-Taste):
  // Drawer offen wie beim Verlassen. Ab 600 (kein Vollbild) wird der Eintrag neutral.
  verlaufWiederherstellen() {
    if (!this._vollbild || !(history.state && history.state.cartDrawer)) return;
    if (this.drawer.classList.contains('cart-drawer--open')) { this._verlauf = true; return; }
    if (this._vollbild.matches) {
      this._verlauf = true;
      this.showPanel();
    } else {
      history.replaceState(null, '');
    }
  },

  // --- Frisch halten: Tab-Rueckkehr und bfcache-Restore ---
  // Ein Drawer, der laenger offen steht oder aus dem Verlauf/bfcache zurueckkommt, kann
  // einen Warenkorb zeigen, den der Browser serverseitig nicht mehr hat (Bestellung in
  // einem anderen Tab oder per Shop-App, Cookie geloescht) — der naechste Mengen-Klick
  // laeuft dann in den 422 (Vorfall 2026-10-09, docs/betrieb.md).
  // Darum gleicht der Drawer im Hintergrund ab:
  //  - pageshow mit persisted (bfcache-Restore): immer. Auf /cart nicht — dort
  //    laedt cart-page.js die ganze Seite neu.
  //  - visibilitychange -> visible: nur, wenn der letzte Server-Stand
  //    ABGLEICH_PAUSE_MS (30 s) alt ist — ein Tab-Wechsel kostet sonst jedes Mal
  //    einen Request.
  // Der 422-Pfad in sendUpdate bleibt das Netz fuer alles, was hier durchrutscht.
  frischHaltenBinden() {
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted || document.querySelector('.cart-page')) return;
      this.abgleichen();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') return;
      if (Date.now() - this._letzterAbgleich < this.ABGLEICH_PAUSE_MS) return;
      this.abgleichen();
    });
  },

  // Hintergrund-Abgleich mit dem Server-Stand. Drei Regeln:
  //  1. Ueberholt wird verworfen: kam waehrend des Abrufs eine Mutation an
  //     (_stand gezaehlt in applySections), laeuft gerade eine (_busy) oder ein
  //     ATC (Ladepunkte), ist deren Antwort neuer als dieser GET.
  //  2. Unveraendert wird nicht getauscht: gleicher Fingerabdruck (Anzahl, Total,
  //     Zeilen-Keys mit Menge) -> nur die Inventar-Map uebernehmen. Kein DOM-Tausch
  //     heisst kein Fokusverlust im offenen Drawer und kein Bild-Flackern.
  //  3. Veraendert wird NICHT silent angewendet: Zaehler, Produktseite (Versand-
  //     balken), GradedGuard und /cart ziehen per cart:updated nach. Kein Loop —
  //     der Abgleich laeuft nur auf echte Aenderung, und die Empfaenger
  //     broadcasten nicht zurueck. Ist der Drawer offen, steht danach derselbe
  //     Hinweis wie im 422-Pfad (die Kundin sah den alten Stand; role="alert"
  //     sagt den Tausch an); geschlossen bleibt er still. Lag der Fokus im
  //     getauschten Teil, geht er aufs Gegenstueck (cartSwapA11y), sonst auf den
  //     Drawer selbst (modalFocus hat ihm tabindex="-1" gegeben; der naechste Tab
  //     landet wieder in der Falle).
  async abgleichen() {
    if (this._abgleichLaeuft || this._busy || this.istAmLaden()) return;
    this._abgleichLaeuft = true;
    this._letzterAbgleich = Date.now();
    const stand = this._stand;
    try {
      const data = await this.holeSections();
      if (this._stand !== stand || this._busy || this.istAmLaden()) return;
      const html = data['cart-drawer'];
      if (!html) return;
      const neu = new DOMParser().parseFromString(html, 'text/html');
      const unveraendert = this.fingerabdruck(neu.getElementById('cart-drawer-body'), neu.getElementById('cart-drawer-footer'))
        === this.fingerabdruck(this.body, this.footer);
      if (unveraendert) {
        if (data['cart-inventory']) this.applyInventory(data['cart-inventory']);
        return;
      }
      const aktiv = document.activeElement;
      const fokusImDrawer = !!aktiv && aktiv !== this.drawer && this.drawer.contains(aktiv);
      const a11y = window.cartSwapA11y.vorher(this.body, null);
      this.applySections(data);
      if (fokusImDrawer && !this.drawer.contains(document.activeElement)) {
        window.cartSwapA11y.fokusZurueck(this.body, a11y, null);
        if (!this.drawer.contains(document.activeElement)) this.drawer.focus({ preventScroll: true });
      }
      if (this.drawer.classList.contains('cart-drawer--open')) this.zeigeHinweis(window.themeStrings.cartChanged, 'info');
    } catch (e) {
      // Best effort (offline beim Tab-Wechsel): der naechste Anlass versucht es wieder.
      console.warn('Cart drawer sync failed:', e);
    } finally {
      this._abgleichLaeuft = false;
    }
  },

  // Fingerabdruck eines Drawer-Stands: Anzahl und Total (data-* am Footer) plus
  // jede Zeile als «Key=Menge» (Menge = gerenderter Feldwert, nie ein getippter).
  fingerabdruck(body, footer) {
    const zeilen = body
      ? Array.from(body.querySelectorAll('.cart-item[data-key]')).map((z) => {
          const feld = z.querySelector('input.cart-item__qty-num');
          return z.dataset.key + '=' + (feld ? feld.defaultValue : '');
        })
      : [];
    return [footer ? footer.dataset.cartCount : '', footer ? footer.dataset.cartTotal : '', zeilen.join(',')].join('|');
  },

  istAmLaden() {
    return !!(this.body && this.body.querySelector('.cart-drawer__loading'));
  },

  // Cart-Icon: Panel instant zeigen (0 Fetch). Frisch-Halten passiert via cart:updated-Listener
  // (nur bei echter Fremdaenderung, silent im Hintergrund) und abgleichen() bei Tab-Rueckkehr
  // bzw. bfcache-Restore -> kein Fetch pro Oeffnen, kein Flicker.
  open() {
    this.showPanel();
  },

  // ATC: Panel + Spinner sofort, ohne Fetch -> Inhalt kommt via applySections nach.
  openLoading() {
    this.loescheHinweis();
    this.showPanel();
    this.showLoading();
  },

  // ATC fehlgeschlagen (HTTP 422, Server- oder Netzfehler) — Audit 2026-10-02 CQ-1/ROB-12:
  // Drawer bleibt OFFEN und zeigt den Server-Stand plus den Kundentext aus
  // hdkCart.addMeldung (nie ein Shopify-Rohtext). Nur schliessen genuegt nicht: der Body
  // bliebe mit den Ladepunkten aus openLoading() stehen, und der naechste
  // Klick aufs Cart-Icon zeigte bis zum Reload einen leeren Warenkorb.
  // Neu laden statt still zuruecksetzen, weil Shopify bei 422 (items-Format) trotzdem
  // einbucht, was verfuegbar ist (Teil-Einbuchung) — nicht silent, damit Zaehler,
  // Produktseite und /cart den neuen Stand per cart:updated mitbekommen.
  // Ist auch der Server nicht erreichbar, kommt der Body von vor dem Laden zurueck.
  async addFehlgeschlagen(meldung) {
    this.showPanel();
    const ok = await this.refreshFromServer();
    if (!ok && this._bodyVorLaden !== null && this.body.querySelector('.cart-drawer__loading')) {
      this.body.innerHTML = this._bodyVorLaden;
    }
    this._bodyVorLaden = null;
    this.zeigeHinweis(meldung);
  },

  // Hinweis-Zeile in der Shell (sections/cart-drawer.liquid, role="alert"). Ohne
  // Shopify-Meldung der lokalisierte Fallback aus data-fallback. art = 'info'
  // schaltet die Zeile auf den neutralen Stil («Warenkorb neu geladen» ist eine
  // Information, kein Fehler — Coral bleibt dem Add-Fehler).
  zeigeHinweis(text, art) {
    if (!this.notice) return;
    this.notice.classList.toggle('cart-drawer__notice--info', art === 'info');
    this.notice.textContent = text || this.notice.dataset.fallback || '';
  },

  loescheHinweis() {
    if (!this.notice) return;
    this.notice.textContent = '';
    this.notice.classList.remove('cart-drawer__notice--info');
  },

  showPanel() {
    const wasOpen = this.drawer.classList.contains('cart-drawer--open');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.overlay.setAttribute('aria-hidden', 'false');
    this.drawer.classList.add('cart-drawer--open');
    this.overlay.classList.add('cart-overlay--visible');
    document.body.classList.add('cart-drawer-active');
    // Fokus ins Panel + Falle (window.modalFocus, theme.js) — nur beim echten
    // Oeffnen, nicht bei showPanel()-Aufrufen auf bereits offenem Drawer (ATC).
    // Ebenso nur dann der Verlaufseintrag des Vollbilds (verlaufBinden).
    if (!wasOpen) {
      this.vorbereiten();
      // Kurzform «Sale» erst jetzt messen (rabattMessen, P-6): synchron vor dem ersten
      // Frame des offenen Drawers, also ohne Aufblitzen der Langform.
      window.cartRabattKurzform(this.body);
      this.hintergrundSperren(true);
      if (window.modalFocus) window.modalFocus.activate(this.drawer);
      this.verlaufSetzen();
    }
  },

  // Seite hinter dem offenen Drawer inert (Block 1 des Warenkorb-Audits, A-3): aria-modal allein
  // reicht nicht — der Chrome-AX-Baum fuehrt bei offenem Drawer sonst weiter Banner, Navigation,
  // Main, Footer und die Ueberschriften der Seite. Inert werden die Geschwister der Drawer-Section unter <body> (Header-, Footer-Gruppe,
  // main, Skip-Link, Fremd-Overlays); ausgenommen die Section selbst (Drawer, Overlay, Mehr-Dialog),
  // Skripte/Styles und der Cookie-Banner <pandectes-cmp> — der muss bedienbar bleiben, solange er
  // unbeantwortet ist (VENDOR:pandectes-escape, docs/vendor-kopplungen.md). Zurueck nur, was hier
  // inert wurde; in close() VOR der Fokus-Rueckgabe (ein inerter Ausloeser nimmt keinen Fokus).
  _inert: [],

  hintergrundSperren(an) {
    if (!an) {
      this._inert.forEach((el) => { el.inert = false; });
      this._inert = [];
      return;
    }
    if (this._inert.length || !('inert' in HTMLElement.prototype)) return;
    const eigen = this.drawer.closest('.shopify-section') || this.drawer;
    this._inert = Array.from(document.body.children).filter((el) => el !== eigen && !el.contains(this.drawer)
      && !/^(script|style|link|template|noscript|pandectes-cmp)$/.test(el.localName) && !el.inert);
    this._inert.forEach((el) => { el.inert = true; });
  },

  istOffen() {
    return this.drawer.classList.contains('cart-drawer--open');
  },

  // Bilder des Drawers erst beim Oeffnen (Audit Warenkorb P-5). loading="lazy"
  // haelt sie nicht zurueck: das geschlossene Panel liegt mit translateX(100%) direkt neben
  // dem Fenster, das Seitenpanel ab 900 sogar darin, und visibility:
  // hidden bremst das Lazy-Loading nicht — sonst laden die Drawer-Bilder
  // auf jeder Seite mit gefuelltem Warenkorb. Darum tragen Zeilen-, Fueller- und
  // Logobilder im Drawer ihre Quellen als data-drawer-src/-srcset (cart-line-item,
  // cart-filler-karte im_drawer, payment-icons bis_oeffnen); vorbereiten() gibt sie frei —
  // bei der Absicht zu oeffnen (init: Zeiger, Fokus, Beruehrung am Warenkorb-Knopf), damit sie
  // bis zum Einfahren da sind, spaetestens in showPanel — und merkt sich das (_bilderFrei):
  // jeder spaetere Swap gibt die neuen Bilder vor dem Einhaengen frei (swapContent).
  // Verworfen: content-visibility: hidden am Panel (laedt nichts, aber Lage-Abfragen
  // in den gesperrten Inhalt erzwingen dessen Layout — Shopifys Web-Pixel-Init im load-Handler
  // wird auf /cart deutlich laenger) und display: none auf den
  // Kindern des Panels (lazy-Bilder darin laden trotzdem, nicht verlaesslich zurueckgehalten).
  _bilderFrei: false,

  vorbereiten() {
    if (this._bilderFrei) return;
    this._bilderFrei = true;
    this.bilderFreigeben(this.drawer);
  },

  bilderFreigeben(wurzel) {
    if (!wurzel) return;
    wurzel.querySelectorAll('img[data-drawer-src]').forEach((img) => {
      if (img.dataset.drawerSrcset) img.setAttribute('srcset', img.dataset.drawerSrcset);
      img.setAttribute('src', img.dataset.drawerSrc);
      img.removeAttribute('data-drawer-src');
      img.removeAttribute('data-drawer-srcset');
    });
  },

  showLoading() {
    // Stand vor den Ladepunkten merken: scheitert danach auch das Neuladen vom
    // Server (Netz weg), stellt addFehlgeschlagen() ihn wieder her.
    if (!this.body.querySelector('.cart-drawer__loading')) this._bodyVorLaden = this.body.innerHTML;
    this.body.innerHTML = `
      <div class="cart-drawer__loading">
        <span class="cart-drawer__loading-dot"></span>
        <span class="cart-drawer__loading-dot"></span>
        <span class="cart-drawer__loading-dot"></span>
      </div>`;
  },

  close() {
    // Guard: der Escape-Handler ruft close() bei JEDEM Escape — ohne Guard wuerde
    // modalFocus.deactivate() den Fokus auch dann umsetzen, wenn der Drawer zu ist.
    if (!this.drawer.classList.contains('cart-drawer--open')) return;
    this.loescheHinweis();
    this.drawer.setAttribute('aria-hidden', 'true');
    this.overlay.setAttribute('aria-hidden', 'true');
    this.drawer.classList.remove('cart-drawer--open');
    this.overlay.classList.remove('cart-overlay--visible');
    document.body.classList.remove('cart-drawer-active');
    this.hintergrundSperren(false);
    if (window.modalFocus) window.modalFocus.deactivate();
    // Eigenen Verlaufseintrag wegnehmen (verlaufBinden). Kam das Schliessen von der
    // Zurueck-Taste, ist _verlauf schon false.
    if (this._verlauf) {
      this._verlauf = false;
      if (this._linkKlick) {
        history.replaceState(null, '');
      } else {
        this._verlaufZurueck = true;
        history.back();
      }
    }
  },

  // --- Sections anwenden -------------------------------------------------

  // sections: { 'cart-drawer': html, 'cart-inventory': html }
  // cart (optional): voller Cart aus /cart/update.js (mit items) -> fuers cart:updated-Event.
  applySections(sections, cart, silent) {
    // Jeder angewendete Server-Stand: Zaehler fuer abgleichen() (ueberholter
    // Hintergrund-Abruf wird verworfen) und Uhr der 30-s-Drossel.
    this._stand++;
    this._letzterAbgleich = Date.now();
    if (sections) {
      if (sections['cart-drawer'])    this.swapContent(sections['cart-drawer']);
      if (sections['cart-inventory']) this.applyInventory(sections['cart-inventory']);
    }
    const count = cart ? cart.item_count
                       : parseInt((this.footer && this.footer.dataset.cartCount) || '0', 10);
    this.updateCounter(count);
    // silent = nur eigener View (z.B. Sync beim Oeffnen) -> kein cart:updated, sonst Endlos-Sync /cart <-> Drawer
    if (!silent) {
      const detail = cart || {
        total_price: parseInt((this.footer && this.footer.dataset.cartTotal) || '0', 10),
        item_count:  count
      };
      this._selfEvent = true;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
      this._selfEvent = false;
    }
  },

  // Body-Inhalt + Footer aus dem zurueckgegebenen Section-HTML austauschen (Shell/Open-State bleibt).
  swapContent(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nb  = doc.getElementById('cart-drawer-body');
    const nf  = doc.getElementById('cart-drawer-footer');
    // Bilder vor dem Einhaengen freigeben, sobald der Drawer sie schon zeigen darf (vorbereiten);
    // sonst bleiben sie bis zum Oeffnen bei data-drawer-src.
    if (this._bilderFrei) this.bilderFreigeben(doc);
    if (nb && this.body) this.body.innerHTML = nb.innerHTML;
    if (nf && this.footer) {
      // Ausloeser des Mehr-Dialogs vor dem Einhaengen freischalten (sonst blitzte der Link auf)
      window.cartMehr.ausloeser(nf);
      const imported = document.importNode(nf, true);  // Footer traegt Inhalt + display + data-cart-*
      this.footer.replaceWith(imported);
      this.footer = imported;
      this.panelKanten();
    }
    // Neue Rabattzeilen kommen ohne is-kurz aus Liquid: sofort messen, wenn der Drawer offen
    // ist; geschlossen misst showPanel beim naechsten Oeffnen (rabattMessen).
    if (nb && this.body) this.rabattMessen();
  },

  // --- Mehr-Dialog aus dem Drawer -----------------------
  // Dieselbe Implementierung wie auf /cart (window.cartMehr oben); der Drawer liefert nur
  // seine Flaeche: Wurzel (Ausschluss = der Fueller-Block mit data-produkt-ids, Ausloeser),
  // Kauf und Fokus-Ersatz. Kauf ueber hdkCart.add mit dem Drawer-Sections-Vertrag und
  // stattDrawer: der Drawer ist schon offen (hinter dem Dialog), der Erfolgsweg
  // window.onCartAdd wuerde nur dasselbe tun; der Fehlerweg addFehlgeschlagen schriebe in die
  // Hinweiszeile des Drawers, die hinter dem Dialog keiner sieht — die Meldung steht darum
  // wie auf /cart an der Karte im Dialog. applySections ohne silent: Zaehler, Produktseite,
  // GradedGuard und /cart ziehen per cart:updated nach.
  mehrOeffnen(art) {
    window.cartMehr.oeffnen(art, {
      wurzel: this.drawer,
      kaufen: (variantId) => this.mehrKaufen(variantId),
      ersatz: () => this.drawer,
      statusId: 'cart-drawer-status',
    });
  },

  async mehrKaufen(variantId) {
    let aus = null;
    this.sperren();
    this.loescheHinweis();
    await window.hdkCart.add([{ id: variantId, quantity: 1 }], {
      stattDrawer: async (ergebnis) => {
        try {
          const sections = ergebnis.ok && ergebnis.daten && ergebnis.daten.sections;
          if (sections) this.applySections(sections);
          // Abgelehnt (422 bucht ein, was verfuegbar ist) oder ohne Sections: Server-Stand
          else await this.refreshFromServer();
          aus = { ok: ergebnis.ok, meldung: ergebnis.meldung, container: this.body, totalEl: document.getElementById('cart-total') };
        } finally {
          this.freigeben();
        }
      }
    });
    return aus;
  },

  // --- Seitenpanel ab 900: Scroll-Kanten ------------------
  // Das Panel zeigt bis zu 12 Karten, 6 davon sichtbar, den Rest per Scroll in der Liste
  // (Hoehe in cart-drawer.css).
  // Der Hinweis auf weitere Karten ist ein Kanten-Fade per mask-image an der Liste selbst,
  // geschaltet ueber has-scroll-start/-end (patterns.md «Scroll-Fade», Mask-Variante der
  // Thumb-Leiste): unten, solange darunter Karten liegen, oben, sobald gescrollt ist. Dieselbe
  // Messung wie dort (scrollTop gegen scrollHeight − clientHeight). Unter 900 ist der Streifen
  // horizontal und hat keinen vertikalen Ueberlauf — die Klassen bleiben aus, das CSS wirkt
  // ohnehin erst ab 900. Die Liste kommt mit jedem Footer-Swap neu: Scroll per Capture am
  // Drawer-Root (scroll blubbert nicht), gemessen beim Start, nach jedem Swap und bei
  // Fensteraenderung (resize statt ResizeObserver am Drawer: der ist ab 494 px Fenster immer
  // 420 px breit, ein Wechsel ueber 900 aendert seine Box nicht). Der geschlossene Drawer ist
  // visibility: hidden und behaelt seine Boxen — die Messung stimmt auch dort.
  panelKanten() {
    const liste = this.footer && this.footer.querySelector('.cart-filler__strip');
    if (!liste) return;
    const max = liste.scrollHeight - liste.clientHeight;
    const ueberlauf = max > 1;
    liste.classList.toggle('has-scroll-start', ueberlauf && liste.scrollTop > 1);
    liste.classList.toggle('has-scroll-end', ueberlauf && liste.scrollTop < max - 1);
  },

  panelKantenBinden() {
    let raf = null;
    const planen = () => { if (!raf) raf = requestAnimationFrame(() => { raf = null; this.panelKanten(); }); };
    this.drawer.addEventListener('scroll', (e) => {
      if (e.target.classList && e.target.classList.contains('cart-filler__strip')) planen();
    }, true);
    window.addEventListener('resize', planen, { passive: true });
    planen();
  },

  // Kurzform «Sale» der Rabattzeilen im Drawer (window.cartRabattKurzform oben):
  // beim Oeffnen (showPanel), nach jedem Swap (swapContent), wenn die Schriften
  // geladen sind (die Breite der Pille haengt an Inter) und bei Breitenaenderung des Bodys —
  // unter 600 px ist der Drawer so breit wie das Fenster (Vollbild), ab 600 85 %/420 px.
  // Alle Wege ausser dem Oeffnen laufen ueber rabattMessen und messen nur bei offenem
  // Drawer (Audit Warenkorb P-6: sonst zwei erzwungene Layouts beim Laden jeder Seite mit
  // «Sale»-Zeile, obwohl der Drawer zu ist); showPanel misst beim Oeffnen synchron nach.
  // Der Body ueberlebt jeden Swap (nur sein Inhalt wird ersetzt), EIN Observer reicht, nie
  // abgemeldet: window.cartRabattKurzform.beobachten (oben, geteilt mit cart-page.js).
  rabattBinden() {
    const messen = () => this.rabattMessen();
    window.cartRabattKurzform.beobachten(this.body, messen);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(messen);
  },

  rabattMessen() {
    if (this.istOffen()) window.cartRabattKurzform(this.body);
  },

  applyInventory(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el  = doc.getElementById('cart-inventory-data');
    if (!el) return;
    try {
      const map = JSON.parse(el.textContent);
      window.variantInventory = window.variantInventory || {};
      Object.assign(window.variantInventory, map);
    } catch (e) { /* ignore */ }
  },

  // Drawer frisch vom Server holen. silent=true: nur View aktualisieren (kein cart:updated) — fuer open()-Sync.
  // Ohne silent (z.B. nach einem abgelehnten Add, addFehlgeschlagen): broadcastet die Aenderung weiter.
  // verwerfbar (Abgleich nach einer Fremdaenderung, Audit R-4): kam waehrend des Abrufs ein neuerer
  // Stand an oder startete eine Mutation, ist diese Antwort ueberholt und wird nicht angewendet —
  // sonst ueberschriebe ein verspaeteter GET den frischen Stand der Mutation.
  // Rueckgabe true = Inhalt ersetzt; false = Fehlschlag oder verworfen (addFehlgeschlagen stellt
  // dann den alten Body her).
  async refreshFromServer(silent, verwerfbar) {
    const stand = this._stand;
    const mutationen = this._mutationen;
    try {
      const data = await this.holeSections();
      if (verwerfbar && (this._stand !== stand || this._mutationen !== mutationen || this._busy)) return false;
      this.applySections(data, undefined, silent);
      return true;
    } catch (e) {
      console.error('Cart drawer refresh failed:', e);
      return false;
    }
  },

  // Section-HTML des Drawers + Inventar vom Server (Fehler werfen).
  async holeSections() {
    const res = await fetch(window.routes.root + '?sections=' + window.hdkCart.SECTIONS_DRAWER);
    if (!res.ok) throw new Error('sections HTTP ' + res.status);
    return res.json();
  },

  // --- Mengen / Entfernen: server-autoritativ, EIN Request pro Aktion -----
  // Kein optimistisches Vorausschreiben: die UI aendert sich erst aus der
  // Server-Antwort. Waehrend eines laufenden Requests ist der Drawer gesperrt (sperren:
  // _busy + .cart-drawer--busy, Liste UND Fusszeile gedimmt, Block 1.4), was waehrenddessen
  // eingegeben wird, merkt sich die Mengenwahl je Zeile und sendet freigeben nach (1.5).
  // Die Mengenwahl selbst (Auswahl, Feld, Klemmung ueber hdk.normalizeQty) ist
  // window.cartMengenwahl (oben, gebunden in init); sie ruft sendUpdate.

  onRemoveClick(btn) {
    const key = btn.dataset.key;
    if (key && this.mengenwahl) this.mengenwahl.absenden(key, 0);
  },

  // Eine Aktion -> sofort /cart/update.js mit der Key-Map (eine Zeile, nach einer Sperre auch
  // mehrere vorgemerkte); die Antwort (frisches Section-HTML) ersetzt den Inhalt. Fokus und
  // Ansage gelten der ersten Zeile.
  async sendUpdate(updates) {
    const keys = Object.keys(updates || {});
    if (!keys.length) return;
    const key = keys[0];
    this.sperren();
    this.loescheHinweis();
    const a11y = window.cartSwapA11y.vorher(this.body, key);
    if (this.mengenwahl) a11y.klemmung = this.mengenwahl.klemmungNehmen(key);
    try {
      // hdkCart.update: Misserfolg -> { ok:false, status, art, meldung } (Fehlerklassen im
      // Kopf von hdkCart). Wirft nicht.
      const r = await window.hdkCart.update(updates, window.hdkCart.SECTIONS_DRAWER);
      if (!r.ok && r.art !== 'abgelehnt') {
        // Netz weg, Zeitgrenze, 429/5xx (Block 0.5: zuruecksetzen plus Meldung, beide Flaechen
        // gleich): nichts neu laden — der Server-Stand ist der, den die
        // Zeile schon zeigt. Mengenwahl auf den Server-Wert, eigene Meldung an der Zeile, der
        // Fokus bleibt beim Control. Kein «Warenkorb hat sich geaendert»: am Warenkorb hat sich
        // nichts geaendert. Eine waehrenddessen gewaehlte Menge
        // ginge denselben Weg — nicht nachsenden.
        console.warn('Cart update failed (' + r.art + '): HTTP ' + r.status + ' ' + r.meldung);
        if (this.mengenwahl) { this.mengenwahl.verwerfen(); keys.forEach((k) => this.mengenwahl.zuruecksetzen(k)); }
        window.hdkCart.zeilenStoerung(this.body, key, window.hdkCart.stoerungsText(r.art));
        return;
      }
      if (!r.ok) {
        // Abgelehnt heisst: der Drawer zeigt einen Warenkorb, den der Server so
        // nicht hat — meist fehlt der cart-Cookie (422 «Parameter updates ist
        // ungültig.», Vorfall 2026-10-09), seltener ist die Zeile weg.
        // Darum: Server-Stand laden (bei verlorenem Cart der Leer-Zustand), nicht
        // silent (Zaehler, Produktseite, /cart ziehen per cart:updated nach),
        // danach der eigene Hinweis in der Shell-Zeile (role="alert", ausserhalb
        // von Body/Footer, ueberlebt den Swap; die Reihenfolge stellt sicher, dass
        // er nach dem Tausch steht). Fokus wie im Erfolgsfall: Gegenstueck in der
        // Zeile, sonst der Schliessen-Knopf. Keine Mengen-Ansage — die Aktion hat
        // nicht gegriffen, der Hinweis ist die Ansage. Shopifys Text nur ins Log.
        // Scheitert auch das Neuladen (Netz weg), bleibt der Stand stehen — ohne
        // Hinweis, der ein Neuladen behaupten wuerde.
        console.warn('Cart update rejected: HTTP ' + r.status + ' ' + r.meldung);
        // Eine waehrenddessen gewaehlte Menge galt der veralteten Anzeige — nicht nachsenden.
        if (this.mengenwahl) this.mengenwahl.verwerfen();
        if (await this.refreshFromServer()) {
          window.cartSwapA11y.fokusZurueck(this.body, a11y, document.getElementById('cart-drawer-close'));
          this.zeigeHinweis(window.themeStrings.cartChanged, 'info');
        }
        return;
      }
      const cart = r.cart;
      this.applySections(cart.sections, cart);
      // A11Y-4: Fokus aufs Gegenstueck, Menge + Total ansagen (Helfer oben).
      window.cartSwapA11y.fokusZurueck(this.body, a11y, document.getElementById('cart-drawer-close'));
      window.cartSwapA11y.ansagen(document.getElementById('cart-drawer-status'), this.body, a11y, document.getElementById('cart-total'));
    } catch (err) {
      // Nur Programmfehler beim Einbauen der Antwort (update wirft nicht):
      // Server-Stand laden, damit die Anzeige nicht halb getauscht stehen bleibt.
      console.error('Cart update failed:', err);
      if (this.mengenwahl) this.mengenwahl.verwerfen();
      this.refreshFromServer();
    } finally {
      this.freigeben();
    }
  },

  // Sperre einer Mutation (Mengenwahl, Entfernen, Fueller-Plus, Kauf im Mehr-Dialog) — wie
  // sperren/freigeben auf /cart (cart-page.js). freigeben sendet danach die vorgemerkten Zeilen
  // (cartMengenwahl.nachziehen) und holt einen waehrenddessen gemeldeten Fremdstand nach
  // (cart:updated-Listener in init), sofern nicht schon die naechste Mutation laeuft.
  sperren() {
    this._busy = true;
    this._mutationen++;
    this.setBusy(true);
  },

  freigeben() {
    this._busy = false;
    this.setBusy(false);
    if (this.mengenwahl) this.mengenwahl.nachziehen();
    if (this._nachholen && !this._busy) {
      this._nachholen = false;
      this.refreshFromServer(true, true);
    }
  },

  // --- Warenkorbfueller: ein Klick, ein Add ------------------------------
  // Kein lokales Zustands-Management noetig: die Antwort tauscht den ganzen
  // Drawer-Inhalt aus (Sections API), der geklickte Knoten ist danach weg.
  // Add ueber hdkCart.add — derselbe Weg wie Produktseite und GradedGuard:
  // Erfolg -> window.onCartAdd, 422/Netzfehler ->
  // addFehlgeschlagen (Server-Stand, Drawer offen, Meldung in der Shell-
  // Hinweiszeile; Fallback-Text cart.filler_error). vorDrawer gibt den Knopf frei,
  // BEVOR der Drawer neu laedt (das Neuladen tauscht den Footer samt Knopf; im
  // Erfolgsfall laeuft die Freigabe ins Leere und schadet nicht); die Sperre des
  // Drawers endet, wenn der Add samt Swap fertig ist.
  async onFillerAdd(btn) {
    if (this._busy) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    this.sperren();
    btn.disabled = true;
    btn.classList.add('cart-filler__add--loading');
    this.loescheHinweis();
    try {
      await window.hdkCart.add([{ id: variantId, quantity: 1 }], {
        fallback: window.themeStrings.fillerError,
        vorDrawer: () => {
          btn.disabled = false;
          btn.classList.remove('cart-filler__add--loading');
        }
      });
    } finally {
      this.freigeben();
    }
  },

  // --- Warenkorbfueller: Maus-Drag auf dem Streifen (< 900) -----------------
  // Zeigergeraete im schmalen Band (Tablet mit Maus, schmales Desktop-Fenster)
  // haben keinen Wisch — der Streifen ist dort nur ueber ein unsichtbares
  // Scrollrad erreichbar. Mechanik = window.hdkDragScroll (theme.js), delegiert am
  // Drawer-Root (ziel): der Streifen wird bei jedem Sections-API-Swap ersetzt, ein
  // direkt gebundener Listener waere danach weg. Nur linke Taste; ab 900 steht der
  // Streifen als Spalte ohne horizontalen Overflow — dann nichts zu ziehen. Die
  // Klasse .is-dragging (Snap aus) erst ab echtem Drag, sonst spraenge der Streifen
  // beim ersten Pixel zurueck.
  bindFillerDrag() {
    window.hdkDragScroll(this.drawer, { ziel: '.cart-filler__strip', nurLinks: true, nurBeiUeberlauf: true });
  },

  // Dim-/Sperr-Signal waehrend eines Requests, am Drawer-Root (ueberlebt jeden Swap; Body-Inhalt
  // und Footer-Knoten werden ersetzt): .cart-drawer--busy dimmt Liste UND Fusszeile mit Kassen-
  // Knopf, Fueller und Mehr-Ausloeser (cart-drawer.css) — wie .cart-page--busy auf /cart
  // (Audit D-6).
  setBusy(on) {
    if (this.drawer) this.drawer.classList.toggle('cart-drawer--busy', on);
  },

  // Name des Header-Warenkorbs mit der Artikelzahl (Audit A-4): serverseitig aus header.cart_aria
  // (one/other), nach jeder Mutation hier nachgezogen — sonst nennt der Name eine andere Zahl
  // als das Badge. Geteilt mit cart-page.js (updateCounter dort).
  zaehlerBenennen(count) {
    const cartBtn = document.querySelector('.header__cart-btn');
    const t = window.themeStrings || {};
    const vorlage = count === 1 ? t.cartAriaOne : t.cartAriaOther;
    if (cartBtn && vorlage && typeof count === 'number' && !isNaN(count)) cartBtn.setAttribute('aria-label', vorlage.replace('__N__', count));
  },

  updateCounter(count) {
    this.zaehlerBenennen(count);
    const cartBtn = document.querySelector('.header__cart-btn');
    if (!cartBtn) return;
    let counter = cartBtn.querySelector('.header__cart-count');
    if (count > 0) {
      if (!counter) {
        counter = document.createElement('span');
        counter.className = 'header__cart-count';
        counter.setAttribute('aria-hidden', 'true');
        // An .header__icon-graphic haengen (der position:relative-Anker des Badges,
        // wie im Server-HTML) — NICHT an den Button: der ist unpositioniert, das
        // absolute Badge ankerte dann am fixierten Sticky-Header und klebte oben
        // rechts am Viewport statt am Icon (nur, wenn die Seite mit leerem Cart
        // geladen und das Badge frisch erzeugt wird).
        (cartBtn.querySelector('.header__icon-graphic') || cartBtn).appendChild(counter);
      }
      counter.textContent = count;
    } else if (counter) {
      counter.remove();
    }
  }

};

window.CartDrawer = CartDrawer;

document.addEventListener('DOMContentLoaded', () => {
  CartDrawer.init();
});

// Erfolgspfad von hdkCart.add (Produktseite, GradedGuard, Fueller im Drawer;
// Fueller-Plus und Dialogkauf auf /cart sowie der Dialogkauf im Drawer enden ueber
// haken.stattDrawer — cart-page.js bzw. CartDrawer.mehrKaufen).
// Liste pruefen: grep -rn "hdkCart.add(" assets snippets sections
// data = Antwort von /cart/add.js; enthaelt .sections, wenn der Aufrufer sie angefordert hat.
window.onCartAdd = async (data) => {
  CartDrawer.showPanel();   // sicherstellen, dass der Drawer offen ist (GradedGuard-Sammel-ATC oeffnet nicht selbst)
  CartDrawer.loescheHinweis();
  CartDrawer._bodyVorLaden = null;
  if (data && data.sections) {
    CartDrawer.applySections(data.sections);
  } else {
    CartDrawer.showLoading();
    await CartDrawer.refreshFromServer();
  }
};
